/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.13.2.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import {optionsTransformer} from '@sekoia/shared/requests/nswagBaseClients/baseClient';
import * as moment from 'moment';

export class BaseClient {
  getBaseUrl(_: string, parsedBaseUrl: string | undefined): string {
    if (parsedBaseUrl) {
      return parsedBaseUrl;
    }

    if (!process.env.OBSERVATIONS_SERVICE_URL) {
      throw new Error('OBSERVATIONS_SERVICE_URL must be set in environment');
    }

    return process.env.OBSERVATIONS_SERVICE_URL;
  }
  
  async transformOptions(options: RequestInit) : Promise<RequestInit> {
    return optionsTransformer.addDefaultHeaders(options);
  }
}

export class StepClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-observations-dev.sekoia.one", baseUrl);
    }

    createStep(formId: string, createStepRequest: CreateStepRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/forms/{formId}/steps";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createStepRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateStep(_response);
        });
    }

    protected processCreateStep(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getSteps(formId: string): Promise<StepResponse[]> {
        let url_ = this.baseUrl + "/api/forms/{formId}/steps";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSteps(_response);
        });
    }

    protected processGetSteps(response: Response): Promise<StepResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StepResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StepResponse[]>(<any>null);
    }

    updateSteps(formId: string, updateStepsRequest: UpdateStepsRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/forms/{formId}/steps";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateStepsRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateSteps(_response);
        });
    }

    protected processUpdateSteps(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    deleteStep(formId: string, stepId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/forms/{formId}/steps/{stepId}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (stepId === undefined || stepId === null)
            throw new Error("The parameter 'stepId' must be defined.");
        url_ = url_.replace("{stepId}", encodeURIComponent("" + stepId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteStep(_response);
        });
    }

    protected processDeleteStep(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class RegistrationClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-observations-dev.sekoia.one", baseUrl);
    }

    createRegistration(residentId: string, body: CreateRegistrationRequestBody): Promise<RegistrationIdResponse> {
        let url_ = this.baseUrl + "/api/registrations/{residentId}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateRegistration(_response);
        });
    }

    protected processCreateRegistration(response: Response): Promise<RegistrationIdResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationIdResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationIdResponse>(<any>null);
    }

    getRegistrations(residentId: string, formId: string, countToTake: number | undefined): Promise<RegistrationResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/forms/{formId}/registrations?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (countToTake === null)
            throw new Error("The parameter 'countToTake' cannot be null.");
        else if (countToTake !== undefined)
            url_ += "countToTake=" + encodeURIComponent("" + countToTake) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRegistrations(_response);
        });
    }

    protected processGetRegistrations(response: Response): Promise<RegistrationResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegistrationResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationResponse[]>(<any>null);
    }

    getRegistration(residentId: string, registrationId: string): Promise<RegistrationResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/registrations/{registrationId}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (registrationId === undefined || registrationId === null)
            throw new Error("The parameter 'registrationId' must be defined.");
        url_ = url_.replace("{registrationId}", encodeURIComponent("" + registrationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRegistration(_response);
        });
    }

    protected processGetRegistration(response: Response): Promise<RegistrationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationResponse>(<any>null);
    }

    deleteRegistration(residentId: string, registrationId: string, request: DeleteRegistrationRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/registrations/{registrationId}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (registrationId === undefined || registrationId === null)
            throw new Error("The parameter 'registrationId' must be defined.");
        url_ = url_.replace("{registrationId}", encodeURIComponent("" + registrationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteRegistration(_response);
        });
    }

    protected processDeleteRegistration(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getRegistrationsAssociatedWithPlanForPeriod(residentId: string, planId: string, from: moment.Moment | undefined, to: moment.Moment | undefined): Promise<RegistrationWithoutAnswersResponse[]> {
        let url_ = this.baseUrl + "/api/registrations/residents/{residentId}/plans/{planId}/period?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (planId === undefined || planId === null)
            throw new Error("The parameter 'planId' must be defined.");
        url_ = url_.replace("{planId}", encodeURIComponent("" + planId));
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRegistrationsAssociatedWithPlanForPeriod(_response);
        });
    }

    protected processGetRegistrationsAssociatedWithPlanForPeriod(response: Response): Promise<RegistrationWithoutAnswersResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegistrationWithoutAnswersResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationWithoutAnswersResponse[]>(<any>null);
    }

    getRegistrationsAssociatedWithNexusVumSubGoalForPeriod(residentId: string, nexusVumSubGoalId: string, from: moment.Moment | undefined, to: moment.Moment | undefined): Promise<RegistrationWithoutAnswersResponse[]> {
        let url_ = this.baseUrl + "/api/registrations/residents/{residentId}/nexusVumSubGoals/{nexusVumSubGoalId}/period?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (nexusVumSubGoalId === undefined || nexusVumSubGoalId === null)
            throw new Error("The parameter 'nexusVumSubGoalId' must be defined.");
        url_ = url_.replace("{nexusVumSubGoalId}", encodeURIComponent("" + nexusVumSubGoalId));
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRegistrationsAssociatedWithNexusVumSubGoalForPeriod(_response);
        });
    }

    protected processGetRegistrationsAssociatedWithNexusVumSubGoalForPeriod(response: Response): Promise<RegistrationWithoutAnswersResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegistrationWithoutAnswersResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationWithoutAnswersResponse[]>(<any>null);
    }

    getRegistrationsForResidents(getRegistrationsRequest: GetRegistrationsRequest): Promise<RegistrationWithoutAnswersResponse[]> {
        let url_ = this.baseUrl + "/api/registrations/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getRegistrationsRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRegistrationsForResidents(_response);
        });
    }

    protected processGetRegistrationsForResidents(response: Response): Promise<RegistrationWithoutAnswersResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegistrationWithoutAnswersResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationWithoutAnswersResponse[]>(<any>null);
    }

    getRegistrationsWithFilter(request: GetRegistrationsWithFilterRequest): Promise<RegistrationResponse[]> {
        let url_ = this.baseUrl + "/api/registrations/report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRegistrationsWithFilter(_response);
        });
    }

    protected processGetRegistrationsWithFilter(response: Response): Promise<RegistrationResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegistrationResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationResponse[]>(<any>null);
    }

    getResidentsWithNoRegistrationsForForms(request: GetRegistrationsWithFilterRequest): Promise<ResidentsWithNoRegistrationsForFormResponse> {
        let url_ = this.baseUrl + "/api/registrations/missing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetResidentsWithNoRegistrationsForForms(_response);
        });
    }

    protected processGetResidentsWithNoRegistrationsForForms(response: Response): Promise<ResidentsWithNoRegistrationsForFormResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResidentsWithNoRegistrationsForFormResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResidentsWithNoRegistrationsForFormResponse>(<any>null);
    }

    getRegistrationsReport(request: GetRegistrationsReportRequest): Promise<RegistrationResponse[]> {
        let url_ = this.baseUrl + "/api/observations/report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRegistrationsReport(_response);
        });
    }

    protected processGetRegistrationsReport(response: Response): Promise<RegistrationResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegistrationResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationResponse[]>(<any>null);
    }
}

export class InternalClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-observations-dev.sekoia.one", baseUrl);
    }

    getFoldersForCustomer(customerId: string): Promise<FolderResponse[]> {
        let url_ = this.baseUrl + "/api/internal/folders/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFoldersForCustomer(_response);
        });
    }

    protected processGetFoldersForCustomer(response: Response): Promise<FolderResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FolderResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FolderResponse[]>(<any>null);
    }

    getFormsForOwnersBatchInternal(request: GetFormsForOwnersBatchInternalRequest): Promise<FormResponse[]> {
        let url_ = this.baseUrl + "/api/forms/batch/internal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFormsForOwnersBatchInternal(_response);
        });
    }

    protected processGetFormsForOwnersBatchInternal(response: Response): Promise<FormResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormResponse[]>(<any>null);
    }

    copyFolder(request: CopyFoldersAndContentRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/folder/copy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCopyFolder(_response);
        });
    }

    protected processCopyFolder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    copyForms(request: CopyFormsRequest): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/forms/copy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCopyForms(_response);
        });
    }

    protected processCopyForms(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export class FormClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-observations-dev.sekoia.one", baseUrl);
    }

    createForm(createFormRequest: CreateFormRequest): Promise<CreateFormIdResponse> {
        let url_ = this.baseUrl + "/api/forms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createFormRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateForm(_response);
        });
    }

    protected processCreateForm(response: Response): Promise<CreateFormIdResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateFormIdResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateFormIdResponse>(<any>null);
    }

    getFormPlanAssociations(formId: string): Promise<PlanAssociationResponse[]> {
        let url_ = this.baseUrl + "/api/forms/{formId}/planAssociations";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFormPlanAssociations(_response);
        });
    }

    protected processGetFormPlanAssociations(response: Response): Promise<PlanAssociationResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlanAssociationResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlanAssociationResponse[]>(<any>null);
    }

    getFormsByResidentAndPlan(residentId: string, planId: string, includeArchived: boolean | undefined): Promise<FormResponse[]> {
        let url_ = this.baseUrl + "/api/forms/residents/{residentId}/plans/{planId}?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (planId === undefined || planId === null)
            throw new Error("The parameter 'planId' must be defined.");
        url_ = url_.replace("{planId}", encodeURIComponent("" + planId));
        if (includeArchived === null)
            throw new Error("The parameter 'includeArchived' cannot be null.");
        else if (includeArchived !== undefined)
            url_ += "IncludeArchived=" + encodeURIComponent("" + includeArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFormsByResidentAndPlan(_response);
        });
    }

    protected processGetFormsByResidentAndPlan(response: Response): Promise<FormResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormResponse[]>(<any>null);
    }

    updatePlanAndResidentRelations(residentId: string, planId: string, requestBody: UpdatePlanAndResidentRelationsRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/forms/residents/{residentId}/plans/{planId}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (planId === undefined || planId === null)
            throw new Error("The parameter 'planId' must be defined.");
        url_ = url_.replace("{planId}", encodeURIComponent("" + planId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestBody);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePlanAndResidentRelations(_response);
        });
    }

    protected processUpdatePlanAndResidentRelations(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getFormsAssociatedWithPlanInPeriod(residentId: string, planId: string, from: moment.Moment | undefined, to: moment.Moment | undefined): Promise<FormResponse[]> {
        let url_ = this.baseUrl + "/api/forms/residents/{residentId}/plans/{planId}/period?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (planId === undefined || planId === null)
            throw new Error("The parameter 'planId' must be defined.");
        url_ = url_.replace("{planId}", encodeURIComponent("" + planId));
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFormsAssociatedWithPlanInPeriod(_response);
        });
    }

    protected processGetFormsAssociatedWithPlanInPeriod(response: Response): Promise<FormResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormResponse[]>(<any>null);
    }

    getFormsAssociatedWithNexusVumSubGoalInPeriod(residentId: string, nexusVumSubGoalId: string, from: moment.Moment | undefined, to: moment.Moment | undefined): Promise<FormResponse[]> {
        let url_ = this.baseUrl + "/api/forms/residents/{residentId}/nexusVumSubGoals/{nexusVumSubGoalId}/period?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (nexusVumSubGoalId === undefined || nexusVumSubGoalId === null)
            throw new Error("The parameter 'nexusVumSubGoalId' must be defined.");
        url_ = url_.replace("{nexusVumSubGoalId}", encodeURIComponent("" + nexusVumSubGoalId));
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFormsAssociatedWithNexusVumSubGoalInPeriod(_response);
        });
    }

    protected processGetFormsAssociatedWithNexusVumSubGoalInPeriod(response: Response): Promise<FormResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormResponse[]>(<any>null);
    }

    getFormsByResidentAndPlans(residentId: string, request: GetFormsByResidentAndPlansBatchRequest): Promise<PlanFormAssociationResponse[]> {
        let url_ = this.baseUrl + "/api/forms/residents/{residentId}/plans/query";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFormsByResidentAndPlans(_response);
        });
    }

    protected processGetFormsByResidentAndPlans(response: Response): Promise<PlanFormAssociationResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlanFormAssociationResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlanFormAssociationResponse[]>(<any>null);
    }

    getFormsForOwnersBatch(request: GetFormsForOwnersBatchRequest): Promise<FormResponse[]> {
        let url_ = this.baseUrl + "/api/forms/batch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFormsForOwnersBatch(_response);
        });
    }

    protected processGetFormsForOwnersBatch(response: Response): Promise<FormResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormResponse[]>(<any>null);
    }

    getFormsForResidentWithStepsAndChoicesIncluded(residentId: string): Promise<FormStepResponse[]> {
        let url_ = this.baseUrl + "/api/forms/residents/{residentId}/includeStepsAndChoices";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFormsForResidentWithStepsAndChoicesIncluded(_response);
        });
    }

    protected processGetFormsForResidentWithStepsAndChoicesIncluded(response: Response): Promise<FormStepResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormStepResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormStepResponse[]>(<any>null);
    }

    getFormWithStepsAndChoicesFilteredDownToResident(residentId: string, formId: string, includeInactiveForm: boolean | undefined, includeArchived: boolean | undefined): Promise<FormStepResponse> {
        let url_ = this.baseUrl + "/api/forms/residents/{residentId}/includeStepsAndChoices/{formId}?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (includeInactiveForm === null)
            throw new Error("The parameter 'includeInactiveForm' cannot be null.");
        else if (includeInactiveForm !== undefined)
            url_ += "includeInactiveForm=" + encodeURIComponent("" + includeInactiveForm) + "&";
        if (includeArchived === null)
            throw new Error("The parameter 'includeArchived' cannot be null.");
        else if (includeArchived !== undefined)
            url_ += "includeArchived=" + encodeURIComponent("" + includeArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFormWithStepsAndChoicesFilteredDownToResident(_response);
        });
    }

    protected processGetFormWithStepsAndChoicesFilteredDownToResident(response: Response): Promise<FormStepResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FormStepResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormStepResponse>(<any>null);
    }

    getFormsWithAssignmentsIncluded(residentId: string, includeArchived: boolean | undefined): Promise<FormAssignmentResponse[]> {
        let url_ = this.baseUrl + "/api/forms/includeAssignments/{residentId}?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (includeArchived === null)
            throw new Error("The parameter 'includeArchived' cannot be null.");
        else if (includeArchived !== undefined)
            url_ += "includeArchived=" + encodeURIComponent("" + includeArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFormsWithAssignmentsIncluded(_response);
        });
    }

    protected processGetFormsWithAssignmentsIncluded(response: Response): Promise<FormAssignmentResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormAssignmentResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormAssignmentResponse[]>(<any>null);
    }

    getFormsWithAssignmentsIncludedByQuery(request: GetFormsWithAssignmentsIncludedByQueryBodyRequest): Promise<FormAssignmentResponse[]> {
        let url_ = this.baseUrl + "/api/forms/includeAssignments/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFormsWithAssignmentsIncludedByQuery(_response);
        });
    }

    protected processGetFormsWithAssignmentsIncludedByQuery(response: Response): Promise<FormAssignmentResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormAssignmentResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormAssignmentResponse[]>(<any>null);
    }

    getFormWithStepsAndChoicesIncluded(formId: string): Promise<FormStepResponse> {
        let url_ = this.baseUrl + "/api/forms/{formId}/includeStepsAndChoices";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFormWithStepsAndChoicesIncluded(_response);
        });
    }

    protected processGetFormWithStepsAndChoicesIncluded(response: Response): Promise<FormStepResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FormStepResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormStepResponse>(<any>null);
    }

    setFormArchivedStatus(formId: string, setFormArchivedStatusRequest: SetFormArchivedStatusRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/forms/{formId}/updatearchived";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(setFormArchivedStatusRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetFormArchivedStatus(_response);
        });
    }

    protected processSetFormArchivedStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    updateForm(formId: string, updateFormRequest: UpdateFormRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/form/{formId}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateFormRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateForm(_response);
        });
    }

    protected processUpdateForm(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    setFutureAssignmentsOnForm(formId: string, request: SetFutureAssignmentsRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/forms/{formId}/futureresidentsassignments";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetFutureAssignmentsOnForm(_response);
        });
    }

    protected processSetFutureAssignmentsOnForm(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getAssignedForFutureResidentsForForm(formId: string): Promise<AssignedForFutureResidentsResponse> {
        let url_ = this.baseUrl + "/api/forms/{formId}/assignedForFutureResidents";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssignedForFutureResidentsForForm(_response);
        });
    }

    protected processGetAssignedForFutureResidentsForForm(response: Response): Promise<AssignedForFutureResidentsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignedForFutureResidentsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignedForFutureResidentsResponse>(<any>null);
    }

    updateNexusVumSubGoalAssociations(residentId: string, nexusVumSubGoalId: string, request: UpdateNexusVumSubGoalAssociationsRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/forms/residents/{residentId}/nexusVumSubGoals/{nexusVumSubGoalId}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (nexusVumSubGoalId === undefined || nexusVumSubGoalId === null)
            throw new Error("The parameter 'nexusVumSubGoalId' must be defined.");
        url_ = url_.replace("{nexusVumSubGoalId}", encodeURIComponent("" + nexusVumSubGoalId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateNexusVumSubGoalAssociations(_response);
        });
    }

    protected processUpdateNexusVumSubGoalAssociations(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getFormsAssociatedWithNexusVumSubGoalId(residentId: string, nexusVumSubGoalIds: string[] | undefined): Promise<FormNexusVumSubGoalAssociationResponse[]> {
        let url_ = this.baseUrl + "/api/forms/residents/{residentId}/nexusVumSubGoals?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (nexusVumSubGoalIds === null)
            throw new Error("The parameter 'nexusVumSubGoalIds' cannot be null.");
        else if (nexusVumSubGoalIds !== undefined)
            nexusVumSubGoalIds && nexusVumSubGoalIds.forEach(item => { url_ += "nexusVumSubGoalIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFormsAssociatedWithNexusVumSubGoalId(_response);
        });
    }

    protected processGetFormsAssociatedWithNexusVumSubGoalId(response: Response): Promise<FormNexusVumSubGoalAssociationResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormNexusVumSubGoalAssociationResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormNexusVumSubGoalAssociationResponse[]>(<any>null);
    }

    getResidentFormsQuery(residentId: string, request: GetFormsByIdBatchRequest): Promise<ResidentFormResponse> {
        let url_ = this.baseUrl + "/api/forms/residents/{residentId}/query";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetResidentFormsQuery(_response);
        });
    }

    protected processGetResidentFormsQuery(response: Response): Promise<ResidentFormResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResidentFormResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResidentFormResponse>(<any>null);
    }

    setIncludeFormInRecords(formId: string, request: SetIncludeFormInRecordRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/forms/{formId}/includeInRecords";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetIncludeFormInRecords(_response);
        });
    }

    protected processSetIncludeFormInRecords(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class FolderClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-observations-dev.sekoia.one", baseUrl);
    }

    createFolder(request: CreateFolderRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/folders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateFolder(_response);
        });
    }

    protected processCreateFolder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getFolders(): Promise<FolderResponse[]> {
        let url_ = this.baseUrl + "/api/folders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFolders(_response);
        });
    }

    protected processGetFolders(response: Response): Promise<FolderResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FolderResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FolderResponse[]>(<any>null);
    }

    updateFolder(folderId: string, updateFolderRequest: UpdateFolderRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/folders/{folderId}";
        if (folderId === undefined || folderId === null)
            throw new Error("The parameter 'folderId' must be defined.");
        url_ = url_.replace("{folderId}", encodeURIComponent("" + folderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateFolderRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateFolder(_response);
        });
    }

    protected processUpdateFolder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    deleteFolder(folderId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/folders/{folderId}";
        if (folderId === undefined || folderId === null)
            throw new Error("The parameter 'folderId' must be defined.");
        url_ = url_.replace("{folderId}", encodeURIComponent("" + folderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteFolder(_response);
        });
    }

    protected processDeleteFolder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ChoiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-observations-dev.sekoia.one", baseUrl);
    }

    createChoice(formId: string, stepId: string, createChoiceRequest: CreateChoiceRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/forms/{formId}/steps/{stepId}/choices";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (stepId === undefined || stepId === null)
            throw new Error("The parameter 'stepId' must be defined.");
        url_ = url_.replace("{stepId}", encodeURIComponent("" + stepId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createChoiceRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateChoice(_response);
        });
    }

    protected processCreateChoice(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    updateChoices(formId: string, stepId: string, updateChoicesRequest: UpdateChoicesRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/forms/{formId}/steps/{stepId}/choices";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (stepId === undefined || stepId === null)
            throw new Error("The parameter 'stepId' must be defined.");
        url_ = url_.replace("{stepId}", encodeURIComponent("" + stepId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateChoicesRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateChoices(_response);
        });
    }

    protected processUpdateChoices(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    deleteChoice(formId: string, stepId: string, choiceId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/forms/{formId}/steps/{stepId}/choices/{choiceId}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (stepId === undefined || stepId === null)
            throw new Error("The parameter 'stepId' must be defined.");
        url_ = url_.replace("{stepId}", encodeURIComponent("" + stepId));
        if (choiceId === undefined || choiceId === null)
            throw new Error("The parameter 'choiceId' must be defined.");
        url_ = url_.replace("{choiceId}", encodeURIComponent("" + choiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteChoice(_response);
        });
    }

    protected processDeleteChoice(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class AssignmentClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-observations-dev.sekoia.one", baseUrl);
    }

    deleteAssignmentsBulk(formId: string, requestFromBody: DeleteAssignmentBulkRequest): Promise<HttpStatusCode> {
        let url_ = this.baseUrl + "/api/forms/{formId}/assignments";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestFromBody);

        let options_ = <RequestInit>{
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAssignmentsBulk(_response);
        });
    }

    protected processDeleteAssignmentsBulk(response: Response): Promise<HttpStatusCode> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HttpStatusCode>(<any>null);
    }

    getResidentsIdsAssignedToFormId(formId: string): Promise<AssignmentResponse[]> {
        let url_ = this.baseUrl + "/api/forms/{formId}/assignments";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetResidentsIdsAssignedToFormId(_response);
        });
    }

    protected processGetResidentsIdsAssignedToFormId(response: Response): Promise<AssignmentResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssignmentResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignmentResponse[]>(<any>null);
    }

    assignToResidents(formId: string, requestFromBody: AssignToResidentsRequest): Promise<HttpStatusCode> {
        let url_ = this.baseUrl + "/api/forms/{formId}/assignments";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestFromBody);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAssignToResidents(_response);
        });
    }

    protected processAssignToResidents(response: Response): Promise<HttpStatusCode> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HttpStatusCode>(<any>null);
    }

    getResidentsIdsAssignedToFormIdsBulk(request: GetResidentsIdsAssignedToFormIdsBulkRequest): Promise<{ [key: string]: AssignmentResponse[]; }> {
        let url_ = this.baseUrl + "/api/forms/assignments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetResidentsIdsAssignedToFormIdsBulk(_response);
        });
    }

    protected processGetResidentsIdsAssignedToFormIdsBulk(response: Response): Promise<{ [key: string]: AssignmentResponse[]; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] ? resultData200[key].map((i: any) => AssignmentResponse.fromJS(i)) : [];
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: AssignmentResponse[]; }>(<any>null);
    }

    updateAssignment(formId: string, residentId: string, assignmentRequest: AssignmentRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/forms/{formId}/assignments/{residentId}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assignmentRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAssignment(_response);
        });
    }

    protected processUpdateAssignment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    assignFormsEnabledForFutureResidentsToResident(residentId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/assignformsfornewresident";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAssignFormsEnabledForFutureResidentsToResident(_response);
        });
    }

    protected processAssignFormsEnabledForFutureResidentsToResident(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class AnswerClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-observations-dev.sekoia.one", baseUrl);
    }

    getAnswers(residentId: string, registrationId: string, registeredAt: moment.Moment | undefined): Promise<AnswerResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/registrations/{registrationId}/answers?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (registrationId === undefined || registrationId === null)
            throw new Error("The parameter 'registrationId' must be defined.");
        url_ = url_.replace("{registrationId}", encodeURIComponent("" + registrationId));
        if (registeredAt === null)
            throw new Error("The parameter 'registeredAt' cannot be null.");
        else if (registeredAt !== undefined)
            url_ += "registeredAt=" + encodeURIComponent(registeredAt ? "" + registeredAt.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAnswers(_response);
        });
    }

    protected processGetAnswers(response: Response): Promise<AnswerResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AnswerResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnswerResponse[]>(<any>null);
    }

    /**
     * @deprecated
     */
    getAnswers2(registrationId: string): Promise<AnswerResponse[]> {
        let url_ = this.baseUrl + "/api/registrations/{registrationId}/answers";
        if (registrationId === undefined || registrationId === null)
            throw new Error("The parameter 'registrationId' must be defined.");
        url_ = url_.replace("{registrationId}", encodeURIComponent("" + registrationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAnswers2(_response);
        });
    }

    protected processGetAnswers2(response: Response): Promise<AnswerResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AnswerResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnswerResponse[]>(<any>null);
    }

    /**
     * @deprecated
     */
    getAnswersByResidentsIdsBatch(answerBatchRequestBody: AnswerBatchRequestBody): Promise<AnswerResponse[]> {
        let url_ = this.baseUrl + "/api/registrations/answers/batch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(answerBatchRequestBody);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAnswersByResidentsIdsBatch(_response);
        });
    }

    protected processGetAnswersByResidentsIdsBatch(response: Response): Promise<AnswerResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AnswerResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnswerResponse[]>(<any>null);
    }

    getAnswersForRegistrations(requestBody: AnswersForRegistrationsRequestsBody): Promise<AnswerResponse[]> {
        let url_ = this.baseUrl + "/api/registrations/answers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestBody);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAnswersForRegistrations(_response);
        });
    }

    protected processGetAnswersForRegistrations(response: Response): Promise<AnswerResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AnswerResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnswerResponse[]>(<any>null);
    }
}

export class CreateStepRequest implements ICreateStepRequest {
    extendedByResidentId?: string | null;
    multiSelectEnabled!: boolean;
    scoreEnabled!: boolean;
    required!: boolean;
    commentEnabled!: boolean;
    stepType!: string;
    title?: string | null;
    unit?: string | null;

    constructor(data?: ICreateStepRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.extendedByResidentId = _data["extendedByResidentId"] !== undefined ? _data["extendedByResidentId"] : <any>null;
            this.multiSelectEnabled = _data["multiSelectEnabled"] !== undefined ? _data["multiSelectEnabled"] : <any>null;
            this.scoreEnabled = _data["scoreEnabled"] !== undefined ? _data["scoreEnabled"] : <any>null;
            this.required = _data["required"] !== undefined ? _data["required"] : <any>null;
            this.commentEnabled = _data["commentEnabled"] !== undefined ? _data["commentEnabled"] : <any>null;
            this.stepType = _data["stepType"] !== undefined ? _data["stepType"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
        }
    }

    static fromJS(data: any): CreateStepRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStepRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extendedByResidentId"] = this.extendedByResidentId !== undefined ? this.extendedByResidentId : <any>null;
        data["multiSelectEnabled"] = this.multiSelectEnabled !== undefined ? this.multiSelectEnabled : <any>null;
        data["scoreEnabled"] = this.scoreEnabled !== undefined ? this.scoreEnabled : <any>null;
        data["required"] = this.required !== undefined ? this.required : <any>null;
        data["commentEnabled"] = this.commentEnabled !== undefined ? this.commentEnabled : <any>null;
        data["stepType"] = this.stepType !== undefined ? this.stepType : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        return data; 
    }
}

export interface ICreateStepRequest {
    extendedByResidentId?: string | null;
    multiSelectEnabled: boolean;
    scoreEnabled: boolean;
    required: boolean;
    commentEnabled: boolean;
    stepType: string;
    title?: string | null;
    unit?: string | null;
}

export class StepResponse implements IStepResponse {
    choices!: ChoiceResponse[];
    extendedByResidentId!: string;
    id!: string;
    multiSelectEnabled!: boolean;
    order!: number;
    scoringEnabled!: boolean;
    commentEnabled!: boolean;
    title!: string;
    type!: StepType;
    required!: boolean;
    description?: string | null;
    descriptiveImagePath?: string | null;
    unit?: string | null;
    equation?: string | null;

    constructor(data?: IStepResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.choices = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["choices"])) {
                this.choices = [] as any;
                for (let item of _data["choices"])
                    this.choices!.push(ChoiceResponse.fromJS(item));
            }
            else {
                this.choices = <any>null;
            }
            this.extendedByResidentId = _data["extendedByResidentId"] !== undefined ? _data["extendedByResidentId"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.multiSelectEnabled = _data["multiSelectEnabled"] !== undefined ? _data["multiSelectEnabled"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.scoringEnabled = _data["scoringEnabled"] !== undefined ? _data["scoringEnabled"] : <any>null;
            this.commentEnabled = _data["commentEnabled"] !== undefined ? _data["commentEnabled"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.required = _data["required"] !== undefined ? _data["required"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.descriptiveImagePath = _data["descriptiveImagePath"] !== undefined ? _data["descriptiveImagePath"] : <any>null;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
            this.equation = _data["equation"] !== undefined ? _data["equation"] : <any>null;
        }
    }

    static fromJS(data: any): StepResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StepResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item.toJSON());
        }
        data["extendedByResidentId"] = this.extendedByResidentId !== undefined ? this.extendedByResidentId : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["multiSelectEnabled"] = this.multiSelectEnabled !== undefined ? this.multiSelectEnabled : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["scoringEnabled"] = this.scoringEnabled !== undefined ? this.scoringEnabled : <any>null;
        data["commentEnabled"] = this.commentEnabled !== undefined ? this.commentEnabled : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["required"] = this.required !== undefined ? this.required : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["descriptiveImagePath"] = this.descriptiveImagePath !== undefined ? this.descriptiveImagePath : <any>null;
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        data["equation"] = this.equation !== undefined ? this.equation : <any>null;
        return data; 
    }
}

export interface IStepResponse {
    choices: ChoiceResponse[];
    extendedByResidentId: string;
    id: string;
    multiSelectEnabled: boolean;
    order: number;
    scoringEnabled: boolean;
    commentEnabled: boolean;
    title: string;
    type: StepType;
    required: boolean;
    description?: string | null;
    descriptiveImagePath?: string | null;
    unit?: string | null;
    equation?: string | null;
}

export class ChoiceResponse implements IChoiceResponse {
    id!: string;
    order!: number;
    score!: number;
    title!: string;

    protected _discriminator: string;

    constructor(data?: IChoiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "ChoiceResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.score = _data["score"] !== undefined ? _data["score"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
        }
    }

    static fromJS(data: any): ChoiceResponse {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "ImageChoiceResponse") {
            let result = new ImageChoiceResponse();
            result.init(data);
            return result;
        }
        let result = new ChoiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator; 
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["score"] = this.score !== undefined ? this.score : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        return data; 
    }
}

export interface IChoiceResponse {
    id: string;
    order: number;
    score: number;
    title: string;
}

export class ImageChoiceResponse extends ChoiceResponse implements IImageChoiceResponse {
    imageUrl!: string;

    constructor(data?: IImageChoiceResponse) {
        super(data);
        this._discriminator = "ImageChoiceResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : <any>null;
        }
    }

    static fromJS(data: any): ImageChoiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImageChoiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IImageChoiceResponse extends IChoiceResponse {
    imageUrl: string;
}

export enum StepType {
    Text = "Text",
    Image = "Image",
    AnswerWithImage = "AnswerWithImage",
    FreeFormText = "FreeFormText",
    Skipped = "Skipped",
    HealthMeasurementBloodGlucose = "HealthMeasurementBloodGlucose",
    HealthMeasurementBloodPressure = "HealthMeasurementBloodPressure",
    HealthMeasurementBodyTemperature = "HealthMeasurementBodyTemperature",
    HealthMeasurementBodyWeight = "HealthMeasurementBodyWeight",
    HealthMeasurementHeartRate = "HealthMeasurementHeartRate",
    HealthMeasurementOxygenSaturation = "HealthMeasurementOxygenSaturation",
    HealthMeasurementRespiratoryRate = "HealthMeasurementRespiratoryRate",
    HealthMeasurementHeight = "HealthMeasurementHeight",
    NumericValue = "NumericValue",
    Calculation = "Calculation",
    Fluids = "Fluids",
}

export class UpdateStepsRequest implements IUpdateStepsRequest {
    steps!: Step[];

    constructor(data?: IUpdateStepsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.steps = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(Step.fromJS(item));
            }
            else {
                this.steps = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateStepsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStepsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateStepsRequest {
    steps: Step[];
}

export class Step implements IStep {
    id!: string;
    multiSelectEnabled?: boolean | null;
    orderIndex!: number;
    scoringEnabled?: boolean | null;
    title!: string;
    required?: boolean | null;
    commentEnabled?: boolean | null;
    description?: string | null;
    descriptiveImage?: DescriptiveImage | null;
    equation?: string | null;

    constructor(data?: IStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.multiSelectEnabled = _data["multiSelectEnabled"] !== undefined ? _data["multiSelectEnabled"] : <any>null;
            this.orderIndex = _data["orderIndex"] !== undefined ? _data["orderIndex"] : <any>null;
            this.scoringEnabled = _data["scoringEnabled"] !== undefined ? _data["scoringEnabled"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.required = _data["required"] !== undefined ? _data["required"] : <any>null;
            this.commentEnabled = _data["commentEnabled"] !== undefined ? _data["commentEnabled"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.descriptiveImage = _data["descriptiveImage"] ? DescriptiveImage.fromJS(_data["descriptiveImage"]) : <any>null;
            this.equation = _data["equation"] !== undefined ? _data["equation"] : <any>null;
        }
    }

    static fromJS(data: any): Step {
        data = typeof data === 'object' ? data : {};
        let result = new Step();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["multiSelectEnabled"] = this.multiSelectEnabled !== undefined ? this.multiSelectEnabled : <any>null;
        data["orderIndex"] = this.orderIndex !== undefined ? this.orderIndex : <any>null;
        data["scoringEnabled"] = this.scoringEnabled !== undefined ? this.scoringEnabled : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["required"] = this.required !== undefined ? this.required : <any>null;
        data["commentEnabled"] = this.commentEnabled !== undefined ? this.commentEnabled : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["descriptiveImage"] = this.descriptiveImage ? this.descriptiveImage.toJSON() : <any>null;
        data["equation"] = this.equation !== undefined ? this.equation : <any>null;
        return data; 
    }
}

export interface IStep {
    id: string;
    multiSelectEnabled?: boolean | null;
    orderIndex: number;
    scoringEnabled?: boolean | null;
    title: string;
    required?: boolean | null;
    commentEnabled?: boolean | null;
    description?: string | null;
    descriptiveImage?: DescriptiveImage | null;
    equation?: string | null;
}

export class DescriptiveImage implements IDescriptiveImage {
    imagePath?: string | null;
    imageData?: string | null;
    deleteImage?: boolean | null;

    constructor(data?: IDescriptiveImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imagePath = _data["imagePath"] !== undefined ? _data["imagePath"] : <any>null;
            this.imageData = _data["imageData"] !== undefined ? _data["imageData"] : <any>null;
            this.deleteImage = _data["deleteImage"] !== undefined ? _data["deleteImage"] : <any>null;
        }
    }

    static fromJS(data: any): DescriptiveImage {
        data = typeof data === 'object' ? data : {};
        let result = new DescriptiveImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imagePath"] = this.imagePath !== undefined ? this.imagePath : <any>null;
        data["imageData"] = this.imageData !== undefined ? this.imageData : <any>null;
        data["deleteImage"] = this.deleteImage !== undefined ? this.deleteImage : <any>null;
        return data; 
    }
}

export interface IDescriptiveImage {
    imagePath?: string | null;
    imageData?: string | null;
    deleteImage?: boolean | null;
}

export class RegistrationIdResponse implements IRegistrationIdResponse {
    registrationId!: string;

    constructor(data?: IRegistrationIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registrationId = _data["registrationId"] !== undefined ? _data["registrationId"] : <any>null;
        }
    }

    static fromJS(data: any): RegistrationIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrationId"] = this.registrationId !== undefined ? this.registrationId : <any>null;
        return data; 
    }
}

export interface IRegistrationIdResponse {
    registrationId: string;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    extensions!: { [key: string]: any; };

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.extensions = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : <any>null;
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["extensions"][key];
                }
            }
            else {
                this.extensions = <any>null;
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        data["instance"] = this.instance !== undefined ? this.instance : <any>null;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = this.extensions[key] !== undefined ? this.extensions[key] : <any>null;
            }
        }
        return data; 
    }
}

export interface IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    extensions: { [key: string]: any; };
}

export class CreateRegistrationRequestBody implements ICreateRegistrationRequestBody {
    answers!: AnswerRequest[];
    comment?: string | null;
    taskInstanceId?: string | null;
    standardTaskId?: string | null;
    taskAssignmentId?: string | null;
    formId!: string;
    observedAt!: moment.Moment;
    employeeIdsToNotify!: string[];

    constructor(data?: ICreateRegistrationRequestBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.answers = [];
            this.employeeIdsToNotify = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(AnswerRequest.fromJS(item));
            }
            else {
                this.answers = <any>null;
            }
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.taskInstanceId = _data["taskInstanceId"] !== undefined ? _data["taskInstanceId"] : <any>null;
            this.standardTaskId = _data["standardTaskId"] !== undefined ? _data["standardTaskId"] : <any>null;
            this.taskAssignmentId = _data["taskAssignmentId"] !== undefined ? _data["taskAssignmentId"] : <any>null;
            this.formId = _data["formId"] !== undefined ? _data["formId"] : <any>null;
            this.observedAt = _data["observedAt"] ? moment(_data["observedAt"].toString()) : <any>null;
            if (Array.isArray(_data["employeeIdsToNotify"])) {
                this.employeeIdsToNotify = [] as any;
                for (let item of _data["employeeIdsToNotify"])
                    this.employeeIdsToNotify!.push(item);
            }
            else {
                this.employeeIdsToNotify = <any>null;
            }
        }
    }

    static fromJS(data: any): CreateRegistrationRequestBody {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegistrationRequestBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["taskInstanceId"] = this.taskInstanceId !== undefined ? this.taskInstanceId : <any>null;
        data["standardTaskId"] = this.standardTaskId !== undefined ? this.standardTaskId : <any>null;
        data["taskAssignmentId"] = this.taskAssignmentId !== undefined ? this.taskAssignmentId : <any>null;
        data["formId"] = this.formId !== undefined ? this.formId : <any>null;
        data["observedAt"] = this.observedAt ? this.observedAt.toISOString() : <any>null;
        if (Array.isArray(this.employeeIdsToNotify)) {
            data["employeeIdsToNotify"] = [];
            for (let item of this.employeeIdsToNotify)
                data["employeeIdsToNotify"].push(item);
        }
        return data; 
    }
}

export interface ICreateRegistrationRequestBody {
    answers: AnswerRequest[];
    comment?: string | null;
    taskInstanceId?: string | null;
    standardTaskId?: string | null;
    taskAssignmentId?: string | null;
    formId: string;
    observedAt: moment.Moment;
    employeeIdsToNotify: string[];
}

export abstract class AnswerRequest implements IAnswerRequest {
    choiceId?: string | null;
    order!: number;
    stepId!: string;
    stepComment?: string | null;
    stepTitle?: string | null;

    protected _discriminator: string;

    constructor(data?: IAnswerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "AnswerRequest";
    }

    init(_data?: any) {
        if (_data) {
            this.choiceId = _data["choiceId"] !== undefined ? _data["choiceId"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.stepId = _data["stepId"] !== undefined ? _data["stepId"] : <any>null;
            this.stepComment = _data["stepComment"] !== undefined ? _data["stepComment"] : <any>null;
            this.stepTitle = _data["stepTitle"] !== undefined ? _data["stepTitle"] : <any>null;
        }
    }

    static fromJS(data: any): AnswerRequest {
        data = typeof data === 'object' ? data : {};
        if (data["swagger_discriminator"] === "TextAnswerRequest") {
            let result = new TextAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "ImageAnswerRequest") {
            let result = new ImageAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "AnswerWithImageRequest") {
            let result = new AnswerWithImageRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "FreeFormTextAnswerRequest") {
            let result = new FreeFormTextAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "SkippedAnswerRequest") {
            let result = new SkippedAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "BloodGlucoseAnswerRequest") {
            let result = new BloodGlucoseAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "HealthMeasurementsAnswerRequest") {
            throw new Error("The abstract class 'HealthMeasurementsAnswerRequest' cannot be instantiated.");
        }
        if (data["swagger_discriminator"] === "BloodPressureAnswerRequest") {
            let result = new BloodPressureAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "BodyTemperatureAnswerRequest") {
            let result = new BodyTemperatureAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "BodyWeightAnswerRequest") {
            let result = new BodyWeightAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "HeartRateAnswerRequest") {
            let result = new HeartRateAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "HeightAnswerRequest") {
            let result = new HeightAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "OxygenSaturationAnswerRequest") {
            let result = new OxygenSaturationAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "RespiratoryRateAnswerRequest") {
            let result = new RespiratoryRateAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "NumericValueAnswerRequest") {
            let result = new NumericValueAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "CalculationAnswerRequest") {
            let result = new CalculationAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "FluidsAnswerRequest") {
            let result = new FluidsAnswerRequest();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'AnswerRequest' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["swagger_discriminator"] = this._discriminator; 
        data["choiceId"] = this.choiceId !== undefined ? this.choiceId : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["stepId"] = this.stepId !== undefined ? this.stepId : <any>null;
        data["stepComment"] = this.stepComment !== undefined ? this.stepComment : <any>null;
        data["stepTitle"] = this.stepTitle !== undefined ? this.stepTitle : <any>null;
        return data; 
    }
}

export interface IAnswerRequest {
    choiceId?: string | null;
    order: number;
    stepId: string;
    stepComment?: string | null;
    stepTitle?: string | null;
}

export class TextAnswerRequest extends AnswerRequest implements ITextAnswerRequest {
    choiceOrder!: number;
    choiceScore!: number;
    choiceTitle?: string | null;
    multiSelectEnabled!: boolean;
    scoringEnabled!: boolean;

    constructor(data?: ITextAnswerRequest) {
        super(data);
        this._discriminator = "TextAnswerRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.choiceOrder = _data["choiceOrder"] !== undefined ? _data["choiceOrder"] : <any>null;
            this.choiceScore = _data["choiceScore"] !== undefined ? _data["choiceScore"] : <any>null;
            this.choiceTitle = _data["choiceTitle"] !== undefined ? _data["choiceTitle"] : <any>null;
            this.multiSelectEnabled = _data["multiSelectEnabled"] !== undefined ? _data["multiSelectEnabled"] : <any>null;
            this.scoringEnabled = _data["scoringEnabled"] !== undefined ? _data["scoringEnabled"] : <any>null;
        }
    }

    static fromJS(data: any): TextAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TextAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["choiceOrder"] = this.choiceOrder !== undefined ? this.choiceOrder : <any>null;
        data["choiceScore"] = this.choiceScore !== undefined ? this.choiceScore : <any>null;
        data["choiceTitle"] = this.choiceTitle !== undefined ? this.choiceTitle : <any>null;
        data["multiSelectEnabled"] = this.multiSelectEnabled !== undefined ? this.multiSelectEnabled : <any>null;
        data["scoringEnabled"] = this.scoringEnabled !== undefined ? this.scoringEnabled : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface ITextAnswerRequest extends IAnswerRequest {
    choiceOrder: number;
    choiceScore: number;
    choiceTitle?: string | null;
    multiSelectEnabled: boolean;
    scoringEnabled: boolean;
}

export class ImageAnswerRequest extends AnswerRequest implements IImageAnswerRequest {
    points!: PointsRequest[];

    constructor(data?: IImageAnswerRequest) {
        super(data);
        if (!data) {
            this.points = [];
        }
        this._discriminator = "ImageAnswerRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["points"])) {
                this.points = [] as any;
                for (let item of _data["points"])
                    this.points!.push(PointsRequest.fromJS(item));
            }
            else {
                this.points = <any>null;
            }
        }
    }

    static fromJS(data: any): ImageAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImageAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.points)) {
            data["points"] = [];
            for (let item of this.points)
                data["points"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IImageAnswerRequest extends IAnswerRequest {
    points: PointsRequest[];
}

export class PointsRequest implements IPointsRequest {
    x!: number;
    y!: number;

    constructor(data?: IPointsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"] !== undefined ? _data["x"] : <any>null;
            this.y = _data["y"] !== undefined ? _data["y"] : <any>null;
        }
    }

    static fromJS(data: any): PointsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PointsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x !== undefined ? this.x : <any>null;
        data["y"] = this.y !== undefined ? this.y : <any>null;
        return data; 
    }
}

export interface IPointsRequest {
    x: number;
    y: number;
}

export class AnswerWithImageRequest extends AnswerRequest implements IAnswerWithImageRequest {
    images!: ImageRequest[];

    constructor(data?: IAnswerWithImageRequest) {
        super(data);
        if (!data) {
            this.images = [];
        }
        this._discriminator = "AnswerWithImageRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ImageRequest.fromJS(item));
            }
            else {
                this.images = <any>null;
            }
        }
    }

    static fromJS(data: any): AnswerWithImageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AnswerWithImageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IAnswerWithImageRequest extends IAnswerRequest {
    images: ImageRequest[];
}

export class ImageRequest implements IImageRequest {
    data!: string;

    constructor(data?: IImageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
        }
    }

    static fromJS(data: any): ImageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data !== undefined ? this.data : <any>null;
        return data; 
    }
}

export interface IImageRequest {
    data: string;
}

export class FreeFormTextAnswerRequest extends AnswerRequest implements IFreeFormTextAnswerRequest {
    freeFormText!: string;

    constructor(data?: IFreeFormTextAnswerRequest) {
        super(data);
        this._discriminator = "FreeFormTextAnswerRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.freeFormText = _data["freeFormText"] !== undefined ? _data["freeFormText"] : <any>null;
        }
    }

    static fromJS(data: any): FreeFormTextAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FreeFormTextAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["freeFormText"] = this.freeFormText !== undefined ? this.freeFormText : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IFreeFormTextAnswerRequest extends IAnswerRequest {
    freeFormText: string;
}

export class SkippedAnswerRequest extends AnswerRequest implements ISkippedAnswerRequest {

    constructor(data?: ISkippedAnswerRequest) {
        super(data);
        this._discriminator = "SkippedAnswerRequest";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SkippedAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SkippedAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface ISkippedAnswerRequest extends IAnswerRequest {
}

export class AnswerResponse implements IAnswerResponse {
    id!: string;
    choiceId!: string;
    choiceTitle!: string;
    customerId!: string;
    formId!: string;
    order!: number;
    registrationId!: string;
    stepId!: string;
    stepTitle!: string;
    stepComment!: string;
    stepCommentEnabled!: boolean;

    protected _discriminator: string;

    constructor(data?: IAnswerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "AnswerResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.choiceId = _data["choiceId"] !== undefined ? _data["choiceId"] : <any>null;
            this.choiceTitle = _data["choiceTitle"] !== undefined ? _data["choiceTitle"] : <any>null;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : <any>null;
            this.formId = _data["formId"] !== undefined ? _data["formId"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
            this.registrationId = _data["registrationId"] !== undefined ? _data["registrationId"] : <any>null;
            this.stepId = _data["stepId"] !== undefined ? _data["stepId"] : <any>null;
            this.stepTitle = _data["stepTitle"] !== undefined ? _data["stepTitle"] : <any>null;
            this.stepComment = _data["stepComment"] !== undefined ? _data["stepComment"] : <any>null;
            this.stepCommentEnabled = _data["stepCommentEnabled"] !== undefined ? _data["stepCommentEnabled"] : <any>null;
        }
    }

    static fromJS(data: any): AnswerResponse {
        data = typeof data === 'object' ? data : {};
        if (data["swagger_discriminator"] === "HealthMeasurementAnswerResponse") {
            let result = new HealthMeasurementAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "TextAnswerResponse") {
            let result = new TextAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "ImageAnswerResponse") {
            let result = new ImageAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "AnswerWithImageResponse") {
            let result = new AnswerWithImageResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "FreeFormTextAnswerResponse") {
            let result = new FreeFormTextAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "SkippedAnswerResponse") {
            let result = new SkippedAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "BloodGlucoseAnswerResponse") {
            let result = new BloodGlucoseAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "BloodPressureAnswerResponse") {
            let result = new BloodPressureAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "BodyTemperatureAnswerResponse") {
            let result = new BodyTemperatureAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "BodyWeightAnswerResponse") {
            let result = new BodyWeightAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "HeightAnswerResponse") {
            let result = new HeightAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "HeartRateAnswerResponse") {
            let result = new HeartRateAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "OxygenSaturationAnswerResponse") {
            let result = new OxygenSaturationAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "RespiratoryRateAnswerResponse") {
            let result = new RespiratoryRateAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "NumericValueAnswerResponse") {
            let result = new NumericValueAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "CalculationAnswerResponse") {
            let result = new CalculationAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "FluidsAnswerResponse") {
            let result = new FluidsAnswerResponse();
            result.init(data);
            return result;
        }
        let result = new AnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["swagger_discriminator"] = this._discriminator; 
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["choiceId"] = this.choiceId !== undefined ? this.choiceId : <any>null;
        data["choiceTitle"] = this.choiceTitle !== undefined ? this.choiceTitle : <any>null;
        data["customerId"] = this.customerId !== undefined ? this.customerId : <any>null;
        data["formId"] = this.formId !== undefined ? this.formId : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        data["registrationId"] = this.registrationId !== undefined ? this.registrationId : <any>null;
        data["stepId"] = this.stepId !== undefined ? this.stepId : <any>null;
        data["stepTitle"] = this.stepTitle !== undefined ? this.stepTitle : <any>null;
        data["stepComment"] = this.stepComment !== undefined ? this.stepComment : <any>null;
        data["stepCommentEnabled"] = this.stepCommentEnabled !== undefined ? this.stepCommentEnabled : <any>null;
        return data; 
    }
}

export interface IAnswerResponse {
    id: string;
    choiceId: string;
    choiceTitle: string;
    customerId: string;
    formId: string;
    order: number;
    registrationId: string;
    stepId: string;
    stepTitle: string;
    stepComment: string;
    stepCommentEnabled: boolean;
}

export class HealthMeasurementAnswerResponse extends AnswerResponse implements IHealthMeasurementAnswerResponse {
    healthMeasurementMeasuredAt!: moment.Moment;
    isHealthMeasurementDeleted!: boolean;
    healthMeasurementDeletedReason?: string | null;

    constructor(data?: IHealthMeasurementAnswerResponse) {
        super(data);
        this._discriminator = "HealthMeasurementAnswerResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.healthMeasurementMeasuredAt = _data["healthMeasurementMeasuredAt"] ? moment(_data["healthMeasurementMeasuredAt"].toString()) : <any>null;
            this.isHealthMeasurementDeleted = _data["isHealthMeasurementDeleted"] !== undefined ? _data["isHealthMeasurementDeleted"] : <any>null;
            this.healthMeasurementDeletedReason = _data["healthMeasurementDeletedReason"] !== undefined ? _data["healthMeasurementDeletedReason"] : <any>null;
        }
    }

    static fromJS(data: any): HealthMeasurementAnswerResponse {
        data = typeof data === 'object' ? data : {};
        if (data["swagger_discriminator"] === "BloodGlucoseAnswerResponse") {
            let result = new BloodGlucoseAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "BloodPressureAnswerResponse") {
            let result = new BloodPressureAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "BodyTemperatureAnswerResponse") {
            let result = new BodyTemperatureAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "BodyWeightAnswerResponse") {
            let result = new BodyWeightAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "HeightAnswerResponse") {
            let result = new HeightAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "HeartRateAnswerResponse") {
            let result = new HeartRateAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "OxygenSaturationAnswerResponse") {
            let result = new OxygenSaturationAnswerResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "RespiratoryRateAnswerResponse") {
            let result = new RespiratoryRateAnswerResponse();
            result.init(data);
            return result;
        }
        let result = new HealthMeasurementAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthMeasurementMeasuredAt"] = this.healthMeasurementMeasuredAt ? this.healthMeasurementMeasuredAt.toISOString() : <any>null;
        data["isHealthMeasurementDeleted"] = this.isHealthMeasurementDeleted !== undefined ? this.isHealthMeasurementDeleted : <any>null;
        data["healthMeasurementDeletedReason"] = this.healthMeasurementDeletedReason !== undefined ? this.healthMeasurementDeletedReason : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IHealthMeasurementAnswerResponse extends IAnswerResponse {
    healthMeasurementMeasuredAt: moment.Moment;
    isHealthMeasurementDeleted: boolean;
    healthMeasurementDeletedReason?: string | null;
}

export class TextAnswerResponse extends AnswerResponse implements ITextAnswerResponse {
    choiceScore!: number;
    multiSelectEnabled!: boolean;
    scoringEnabled!: boolean;
    choiceOrder!: number;

    constructor(data?: ITextAnswerResponse) {
        super(data);
        this._discriminator = "TextAnswerResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.choiceScore = _data["choiceScore"] !== undefined ? _data["choiceScore"] : <any>null;
            this.multiSelectEnabled = _data["multiSelectEnabled"] !== undefined ? _data["multiSelectEnabled"] : <any>null;
            this.scoringEnabled = _data["scoringEnabled"] !== undefined ? _data["scoringEnabled"] : <any>null;
            this.choiceOrder = _data["choiceOrder"] !== undefined ? _data["choiceOrder"] : <any>null;
        }
    }

    static fromJS(data: any): TextAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TextAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["choiceScore"] = this.choiceScore !== undefined ? this.choiceScore : <any>null;
        data["multiSelectEnabled"] = this.multiSelectEnabled !== undefined ? this.multiSelectEnabled : <any>null;
        data["scoringEnabled"] = this.scoringEnabled !== undefined ? this.scoringEnabled : <any>null;
        data["choiceOrder"] = this.choiceOrder !== undefined ? this.choiceOrder : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface ITextAnswerResponse extends IAnswerResponse {
    choiceScore: number;
    multiSelectEnabled: boolean;
    scoringEnabled: boolean;
    choiceOrder: number;
}

export class ImageAnswerResponse extends AnswerResponse implements IImageAnswerResponse {
    points!: PointResponse[];
    imageUrl!: string;

    constructor(data?: IImageAnswerResponse) {
        super(data);
        if (!data) {
            this.points = [];
        }
        this._discriminator = "ImageAnswerResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["points"])) {
                this.points = [] as any;
                for (let item of _data["points"])
                    this.points!.push(PointResponse.fromJS(item));
            }
            else {
                this.points = <any>null;
            }
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : <any>null;
        }
    }

    static fromJS(data: any): ImageAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImageAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.points)) {
            data["points"] = [];
            for (let item of this.points)
                data["points"].push(item.toJSON());
        }
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IImageAnswerResponse extends IAnswerResponse {
    points: PointResponse[];
    imageUrl: string;
}

export class PointResponse implements IPointResponse {
    y!: number;
    x!: number;

    constructor(data?: IPointResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.y = _data["y"] !== undefined ? _data["y"] : <any>null;
            this.x = _data["x"] !== undefined ? _data["x"] : <any>null;
        }
    }

    static fromJS(data: any): PointResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PointResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["y"] = this.y !== undefined ? this.y : <any>null;
        data["x"] = this.x !== undefined ? this.x : <any>null;
        return data; 
    }
}

export interface IPointResponse {
    y: number;
    x: number;
}

export class AnswerWithImageResponse extends AnswerResponse implements IAnswerWithImageResponse {
    images!: ImageResponse[];

    constructor(data?: IAnswerWithImageResponse) {
        super(data);
        if (!data) {
            this.images = [];
        }
        this._discriminator = "AnswerWithImageResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ImageResponse.fromJS(item));
            }
            else {
                this.images = <any>null;
            }
        }
    }

    static fromJS(data: any): AnswerWithImageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AnswerWithImageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IAnswerWithImageResponse extends IAnswerResponse {
    images: ImageResponse[];
}

export class ImageResponse implements IImageResponse {
    imageUrl!: string;

    constructor(data?: IImageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : <any>null;
        }
    }

    static fromJS(data: any): ImageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : <any>null;
        return data; 
    }
}

export interface IImageResponse {
    imageUrl: string;
}

export class FreeFormTextAnswerResponse extends AnswerResponse implements IFreeFormTextAnswerResponse {
    freeFormText!: string;

    constructor(data?: IFreeFormTextAnswerResponse) {
        super(data);
        this._discriminator = "FreeFormTextAnswerResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.freeFormText = _data["freeFormText"] !== undefined ? _data["freeFormText"] : <any>null;
        }
    }

    static fromJS(data: any): FreeFormTextAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FreeFormTextAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["freeFormText"] = this.freeFormText !== undefined ? this.freeFormText : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IFreeFormTextAnswerResponse extends IAnswerResponse {
    freeFormText: string;
}

export class SkippedAnswerResponse extends AnswerResponse implements ISkippedAnswerResponse {

    constructor(data?: ISkippedAnswerResponse) {
        super(data);
        this._discriminator = "SkippedAnswerResponse";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SkippedAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SkippedAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface ISkippedAnswerResponse extends IAnswerResponse {
}

export class BloodGlucoseAnswerResponse extends HealthMeasurementAnswerResponse implements IBloodGlucoseAnswerResponse {
    level!: number;

    constructor(data?: IBloodGlucoseAnswerResponse) {
        super(data);
        this._discriminator = "BloodGlucoseAnswerResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.level = _data["level"] !== undefined ? _data["level"] : <any>null;
        }
    }

    static fromJS(data: any): BloodGlucoseAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BloodGlucoseAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level !== undefined ? this.level : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IBloodGlucoseAnswerResponse extends IHealthMeasurementAnswerResponse {
    level: number;
}

export class BloodPressureAnswerResponse extends HealthMeasurementAnswerResponse implements IBloodPressureAnswerResponse {
    systolic!: number;
    diastolic!: number;

    constructor(data?: IBloodPressureAnswerResponse) {
        super(data);
        this._discriminator = "BloodPressureAnswerResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.systolic = _data["systolic"] !== undefined ? _data["systolic"] : <any>null;
            this.diastolic = _data["diastolic"] !== undefined ? _data["diastolic"] : <any>null;
        }
    }

    static fromJS(data: any): BloodPressureAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BloodPressureAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systolic"] = this.systolic !== undefined ? this.systolic : <any>null;
        data["diastolic"] = this.diastolic !== undefined ? this.diastolic : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IBloodPressureAnswerResponse extends IHealthMeasurementAnswerResponse {
    systolic: number;
    diastolic: number;
}

export class BodyTemperatureAnswerResponse extends HealthMeasurementAnswerResponse implements IBodyTemperatureAnswerResponse {
    temperature!: number;

    constructor(data?: IBodyTemperatureAnswerResponse) {
        super(data);
        this._discriminator = "BodyTemperatureAnswerResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.temperature = _data["temperature"] !== undefined ? _data["temperature"] : <any>null;
        }
    }

    static fromJS(data: any): BodyTemperatureAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BodyTemperatureAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["temperature"] = this.temperature !== undefined ? this.temperature : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IBodyTemperatureAnswerResponse extends IHealthMeasurementAnswerResponse {
    temperature: number;
}

export class BodyWeightAnswerResponse extends HealthMeasurementAnswerResponse implements IBodyWeightAnswerResponse {
    weight!: number;

    constructor(data?: IBodyWeightAnswerResponse) {
        super(data);
        this._discriminator = "BodyWeightAnswerResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.weight = _data["weight"] !== undefined ? _data["weight"] : <any>null;
        }
    }

    static fromJS(data: any): BodyWeightAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BodyWeightAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weight"] = this.weight !== undefined ? this.weight : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IBodyWeightAnswerResponse extends IHealthMeasurementAnswerResponse {
    weight: number;
}

export class HeightAnswerResponse extends HealthMeasurementAnswerResponse implements IHeightAnswerResponse {
    heightValue!: number;

    constructor(data?: IHeightAnswerResponse) {
        super(data);
        this._discriminator = "HeightAnswerResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.heightValue = _data["heightValue"] !== undefined ? _data["heightValue"] : <any>null;
        }
    }

    static fromJS(data: any): HeightAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HeightAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["heightValue"] = this.heightValue !== undefined ? this.heightValue : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IHeightAnswerResponse extends IHealthMeasurementAnswerResponse {
    heightValue: number;
}

export class HeartRateAnswerResponse extends HealthMeasurementAnswerResponse implements IHeartRateAnswerResponse {
    rate!: number;

    constructor(data?: IHeartRateAnswerResponse) {
        super(data);
        this._discriminator = "HeartRateAnswerResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rate = _data["rate"] !== undefined ? _data["rate"] : <any>null;
        }
    }

    static fromJS(data: any): HeartRateAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HeartRateAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rate"] = this.rate !== undefined ? this.rate : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IHeartRateAnswerResponse extends IHealthMeasurementAnswerResponse {
    rate: number;
}

export class OxygenSaturationAnswerResponse extends HealthMeasurementAnswerResponse implements IOxygenSaturationAnswerResponse {
    level!: number;

    constructor(data?: IOxygenSaturationAnswerResponse) {
        super(data);
        this._discriminator = "OxygenSaturationAnswerResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.level = _data["level"] !== undefined ? _data["level"] : <any>null;
        }
    }

    static fromJS(data: any): OxygenSaturationAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OxygenSaturationAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level !== undefined ? this.level : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IOxygenSaturationAnswerResponse extends IHealthMeasurementAnswerResponse {
    level: number;
}

export class RespiratoryRateAnswerResponse extends HealthMeasurementAnswerResponse implements IRespiratoryRateAnswerResponse {
    rate!: number;

    constructor(data?: IRespiratoryRateAnswerResponse) {
        super(data);
        this._discriminator = "RespiratoryRateAnswerResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rate = _data["rate"] !== undefined ? _data["rate"] : <any>null;
        }
    }

    static fromJS(data: any): RespiratoryRateAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RespiratoryRateAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rate"] = this.rate !== undefined ? this.rate : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IRespiratoryRateAnswerResponse extends IHealthMeasurementAnswerResponse {
    rate: number;
}

export class NumericValueAnswerResponse extends AnswerResponse implements INumericValueAnswerResponse {
    unit!: string;
    numericValue!: number;

    constructor(data?: INumericValueAnswerResponse) {
        super(data);
        this._discriminator = "NumericValueAnswerResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
            this.numericValue = _data["numericValue"] !== undefined ? _data["numericValue"] : <any>null;
        }
    }

    static fromJS(data: any): NumericValueAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NumericValueAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        data["numericValue"] = this.numericValue !== undefined ? this.numericValue : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface INumericValueAnswerResponse extends IAnswerResponse {
    unit: string;
    numericValue: number;
}

export class CalculationAnswerResponse extends AnswerResponse implements ICalculationAnswerResponse {
    calculatedValue!: number;

    constructor(data?: ICalculationAnswerResponse) {
        super(data);
        this._discriminator = "CalculationAnswerResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.calculatedValue = _data["calculatedValue"] !== undefined ? _data["calculatedValue"] : <any>null;
        }
    }

    static fromJS(data: any): CalculationAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calculatedValue"] = this.calculatedValue !== undefined ? this.calculatedValue : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface ICalculationAnswerResponse extends IAnswerResponse {
    calculatedValue: number;
}

export class FluidsAnswerResponse extends AnswerResponse implements IFluidsAnswerResponse {
    fluidsAmountOfferedInMl?: number | null;
    fluidsAmountConsumedInMl?: number | null;
    fluidsFollowUpRegistrationId?: number | null;
    fluidsFollowUpCompletedByEmployeeId?: string | null;
    offeredRegistrationTime!: moment.Moment;
    consumedRegistrationTime?: moment.Moment | null;
    offeredAmountUnknown!: boolean;
    offeredTimeUnknown!: boolean;
    fluidType!: string;

    constructor(data?: IFluidsAnswerResponse) {
        super(data);
        this._discriminator = "FluidsAnswerResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fluidsAmountOfferedInMl = _data["fluidsAmountOfferedInMl"] !== undefined ? _data["fluidsAmountOfferedInMl"] : <any>null;
            this.fluidsAmountConsumedInMl = _data["fluidsAmountConsumedInMl"] !== undefined ? _data["fluidsAmountConsumedInMl"] : <any>null;
            this.fluidsFollowUpRegistrationId = _data["fluidsFollowUpRegistrationId"] !== undefined ? _data["fluidsFollowUpRegistrationId"] : <any>null;
            this.fluidsFollowUpCompletedByEmployeeId = _data["fluidsFollowUpCompletedByEmployeeId"] !== undefined ? _data["fluidsFollowUpCompletedByEmployeeId"] : <any>null;
            this.offeredRegistrationTime = _data["offeredRegistrationTime"] ? moment(_data["offeredRegistrationTime"].toString()) : <any>null;
            this.consumedRegistrationTime = _data["consumedRegistrationTime"] ? moment(_data["consumedRegistrationTime"].toString()) : <any>null;
            this.offeredAmountUnknown = _data["offeredAmountUnknown"] !== undefined ? _data["offeredAmountUnknown"] : <any>null;
            this.offeredTimeUnknown = _data["offeredTimeUnknown"] !== undefined ? _data["offeredTimeUnknown"] : <any>null;
            this.fluidType = _data["fluidType"] !== undefined ? _data["fluidType"] : <any>null;
        }
    }

    static fromJS(data: any): FluidsAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FluidsAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fluidsAmountOfferedInMl"] = this.fluidsAmountOfferedInMl !== undefined ? this.fluidsAmountOfferedInMl : <any>null;
        data["fluidsAmountConsumedInMl"] = this.fluidsAmountConsumedInMl !== undefined ? this.fluidsAmountConsumedInMl : <any>null;
        data["fluidsFollowUpRegistrationId"] = this.fluidsFollowUpRegistrationId !== undefined ? this.fluidsFollowUpRegistrationId : <any>null;
        data["fluidsFollowUpCompletedByEmployeeId"] = this.fluidsFollowUpCompletedByEmployeeId !== undefined ? this.fluidsFollowUpCompletedByEmployeeId : <any>null;
        data["offeredRegistrationTime"] = this.offeredRegistrationTime ? this.offeredRegistrationTime.toISOString() : <any>null;
        data["consumedRegistrationTime"] = this.consumedRegistrationTime ? this.consumedRegistrationTime.toISOString() : <any>null;
        data["offeredAmountUnknown"] = this.offeredAmountUnknown !== undefined ? this.offeredAmountUnknown : <any>null;
        data["offeredTimeUnknown"] = this.offeredTimeUnknown !== undefined ? this.offeredTimeUnknown : <any>null;
        data["fluidType"] = this.fluidType !== undefined ? this.fluidType : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IFluidsAnswerResponse extends IAnswerResponse {
    fluidsAmountOfferedInMl?: number | null;
    fluidsAmountConsumedInMl?: number | null;
    fluidsFollowUpRegistrationId?: number | null;
    fluidsFollowUpCompletedByEmployeeId?: string | null;
    offeredRegistrationTime: moment.Moment;
    consumedRegistrationTime?: moment.Moment | null;
    offeredAmountUnknown: boolean;
    offeredTimeUnknown: boolean;
    fluidType: string;
}

export abstract class HealthMeasurementsAnswerRequest extends AnswerRequest implements IHealthMeasurementsAnswerRequest {
    healthMeasurementMeasuredAt!: moment.Moment;

    constructor(data?: IHealthMeasurementsAnswerRequest) {
        super(data);
        this._discriminator = "HealthMeasurementsAnswerRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.healthMeasurementMeasuredAt = _data["healthMeasurementMeasuredAt"] ? moment(_data["healthMeasurementMeasuredAt"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): HealthMeasurementsAnswerRequest {
        data = typeof data === 'object' ? data : {};
        if (data["swagger_discriminator"] === "BloodGlucoseAnswerRequest") {
            let result = new BloodGlucoseAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "BloodPressureAnswerRequest") {
            let result = new BloodPressureAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "BodyTemperatureAnswerRequest") {
            let result = new BodyTemperatureAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "BodyWeightAnswerRequest") {
            let result = new BodyWeightAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "HeartRateAnswerRequest") {
            let result = new HeartRateAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "HeightAnswerRequest") {
            let result = new HeightAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "OxygenSaturationAnswerRequest") {
            let result = new OxygenSaturationAnswerRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "RespiratoryRateAnswerRequest") {
            let result = new RespiratoryRateAnswerRequest();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'HealthMeasurementsAnswerRequest' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthMeasurementMeasuredAt"] = this.healthMeasurementMeasuredAt ? this.healthMeasurementMeasuredAt.toISOString() : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IHealthMeasurementsAnswerRequest extends IAnswerRequest {
    healthMeasurementMeasuredAt: moment.Moment;
}

export class BloodGlucoseAnswerRequest extends HealthMeasurementsAnswerRequest implements IBloodGlucoseAnswerRequest {
    level?: number | null;

    constructor(data?: IBloodGlucoseAnswerRequest) {
        super(data);
        this._discriminator = "BloodGlucoseAnswerRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.level = _data["level"] !== undefined ? _data["level"] : <any>null;
        }
    }

    static fromJS(data: any): BloodGlucoseAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BloodGlucoseAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level !== undefined ? this.level : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IBloodGlucoseAnswerRequest extends IHealthMeasurementsAnswerRequest {
    level?: number | null;
}

export class BloodPressureAnswerRequest extends HealthMeasurementsAnswerRequest implements IBloodPressureAnswerRequest {
    systolic?: number | null;
    diastolic?: number | null;

    constructor(data?: IBloodPressureAnswerRequest) {
        super(data);
        this._discriminator = "BloodPressureAnswerRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.systolic = _data["systolic"] !== undefined ? _data["systolic"] : <any>null;
            this.diastolic = _data["diastolic"] !== undefined ? _data["diastolic"] : <any>null;
        }
    }

    static fromJS(data: any): BloodPressureAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BloodPressureAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systolic"] = this.systolic !== undefined ? this.systolic : <any>null;
        data["diastolic"] = this.diastolic !== undefined ? this.diastolic : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IBloodPressureAnswerRequest extends IHealthMeasurementsAnswerRequest {
    systolic?: number | null;
    diastolic?: number | null;
}

export class BodyTemperatureAnswerRequest extends HealthMeasurementsAnswerRequest implements IBodyTemperatureAnswerRequest {
    temperature?: number | null;

    constructor(data?: IBodyTemperatureAnswerRequest) {
        super(data);
        this._discriminator = "BodyTemperatureAnswerRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.temperature = _data["temperature"] !== undefined ? _data["temperature"] : <any>null;
        }
    }

    static fromJS(data: any): BodyTemperatureAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BodyTemperatureAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["temperature"] = this.temperature !== undefined ? this.temperature : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IBodyTemperatureAnswerRequest extends IHealthMeasurementsAnswerRequest {
    temperature?: number | null;
}

export class BodyWeightAnswerRequest extends HealthMeasurementsAnswerRequest implements IBodyWeightAnswerRequest {
    weight?: number | null;

    constructor(data?: IBodyWeightAnswerRequest) {
        super(data);
        this._discriminator = "BodyWeightAnswerRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.weight = _data["weight"] !== undefined ? _data["weight"] : <any>null;
        }
    }

    static fromJS(data: any): BodyWeightAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BodyWeightAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weight"] = this.weight !== undefined ? this.weight : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IBodyWeightAnswerRequest extends IHealthMeasurementsAnswerRequest {
    weight?: number | null;
}

export class HeartRateAnswerRequest extends HealthMeasurementsAnswerRequest implements IHeartRateAnswerRequest {
    rate?: number | null;

    constructor(data?: IHeartRateAnswerRequest) {
        super(data);
        this._discriminator = "HeartRateAnswerRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rate = _data["rate"] !== undefined ? _data["rate"] : <any>null;
        }
    }

    static fromJS(data: any): HeartRateAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HeartRateAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rate"] = this.rate !== undefined ? this.rate : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IHeartRateAnswerRequest extends IHealthMeasurementsAnswerRequest {
    rate?: number | null;
}

export class HeightAnswerRequest extends HealthMeasurementsAnswerRequest implements IHeightAnswerRequest {
    heightValue?: number | null;

    constructor(data?: IHeightAnswerRequest) {
        super(data);
        this._discriminator = "HeightAnswerRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.heightValue = _data["heightValue"] !== undefined ? _data["heightValue"] : <any>null;
        }
    }

    static fromJS(data: any): HeightAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HeightAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["heightValue"] = this.heightValue !== undefined ? this.heightValue : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IHeightAnswerRequest extends IHealthMeasurementsAnswerRequest {
    heightValue?: number | null;
}

export class OxygenSaturationAnswerRequest extends HealthMeasurementsAnswerRequest implements IOxygenSaturationAnswerRequest {
    level?: number | null;

    constructor(data?: IOxygenSaturationAnswerRequest) {
        super(data);
        this._discriminator = "OxygenSaturationAnswerRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.level = _data["level"] !== undefined ? _data["level"] : <any>null;
        }
    }

    static fromJS(data: any): OxygenSaturationAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OxygenSaturationAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level !== undefined ? this.level : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IOxygenSaturationAnswerRequest extends IHealthMeasurementsAnswerRequest {
    level?: number | null;
}

export class RespiratoryRateAnswerRequest extends HealthMeasurementsAnswerRequest implements IRespiratoryRateAnswerRequest {
    rate?: number | null;

    constructor(data?: IRespiratoryRateAnswerRequest) {
        super(data);
        this._discriminator = "RespiratoryRateAnswerRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rate = _data["rate"] !== undefined ? _data["rate"] : <any>null;
        }
    }

    static fromJS(data: any): RespiratoryRateAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RespiratoryRateAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rate"] = this.rate !== undefined ? this.rate : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IRespiratoryRateAnswerRequest extends IHealthMeasurementsAnswerRequest {
    rate?: number | null;
}

export class NumericValueAnswerRequest extends AnswerRequest implements INumericValueAnswerRequest {
    numericValue?: number | null;
    unit!: string;

    constructor(data?: INumericValueAnswerRequest) {
        super(data);
        this._discriminator = "NumericValueAnswerRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.numericValue = _data["numericValue"] !== undefined ? _data["numericValue"] : <any>null;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
        }
    }

    static fromJS(data: any): NumericValueAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NumericValueAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numericValue"] = this.numericValue !== undefined ? this.numericValue : <any>null;
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface INumericValueAnswerRequest extends IAnswerRequest {
    numericValue?: number | null;
    unit: string;
}

export class CalculationAnswerRequest extends AnswerRequest implements ICalculationAnswerRequest {
    calculatedValue?: number | null;

    constructor(data?: ICalculationAnswerRequest) {
        super(data);
        this._discriminator = "CalculationAnswerRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.calculatedValue = _data["calculatedValue"] !== undefined ? _data["calculatedValue"] : <any>null;
        }
    }

    static fromJS(data: any): CalculationAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calculatedValue"] = this.calculatedValue !== undefined ? this.calculatedValue : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface ICalculationAnswerRequest extends IAnswerRequest {
    calculatedValue?: number | null;
}

export class FluidsAnswerRequest extends AnswerRequest implements IFluidsAnswerRequest {
    fluidsAmountOfferedInMl!: number;
    fluidsAmountConsumedInMl?: number | null;
    offeredAmountUnknown!: boolean;
    offeredTimeUnknown!: boolean;
    offeredRegistrationTime!: moment.Moment;
    fluidType!: string;
    requiresFollowUp!: boolean;
    followUpTimeFrom!: moment.Moment;
    followUpTimeTo!: moment.Moment;

    constructor(data?: IFluidsAnswerRequest) {
        super(data);
        this._discriminator = "FluidsAnswerRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fluidsAmountOfferedInMl = _data["fluidsAmountOfferedInMl"] !== undefined ? _data["fluidsAmountOfferedInMl"] : <any>null;
            this.fluidsAmountConsumedInMl = _data["fluidsAmountConsumedInMl"] !== undefined ? _data["fluidsAmountConsumedInMl"] : <any>null;
            this.offeredAmountUnknown = _data["offeredAmountUnknown"] !== undefined ? _data["offeredAmountUnknown"] : <any>null;
            this.offeredTimeUnknown = _data["offeredTimeUnknown"] !== undefined ? _data["offeredTimeUnknown"] : <any>null;
            this.offeredRegistrationTime = _data["offeredRegistrationTime"] ? moment(_data["offeredRegistrationTime"].toString()) : <any>null;
            this.fluidType = _data["fluidType"] !== undefined ? _data["fluidType"] : <any>null;
            this.requiresFollowUp = _data["requiresFollowUp"] !== undefined ? _data["requiresFollowUp"] : <any>null;
            this.followUpTimeFrom = _data["followUpTimeFrom"] ? moment(_data["followUpTimeFrom"].toString()) : <any>null;
            this.followUpTimeTo = _data["followUpTimeTo"] ? moment(_data["followUpTimeTo"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): FluidsAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FluidsAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fluidsAmountOfferedInMl"] = this.fluidsAmountOfferedInMl !== undefined ? this.fluidsAmountOfferedInMl : <any>null;
        data["fluidsAmountConsumedInMl"] = this.fluidsAmountConsumedInMl !== undefined ? this.fluidsAmountConsumedInMl : <any>null;
        data["offeredAmountUnknown"] = this.offeredAmountUnknown !== undefined ? this.offeredAmountUnknown : <any>null;
        data["offeredTimeUnknown"] = this.offeredTimeUnknown !== undefined ? this.offeredTimeUnknown : <any>null;
        data["offeredRegistrationTime"] = this.offeredRegistrationTime ? this.offeredRegistrationTime.toISOString() : <any>null;
        data["fluidType"] = this.fluidType !== undefined ? this.fluidType : <any>null;
        data["requiresFollowUp"] = this.requiresFollowUp !== undefined ? this.requiresFollowUp : <any>null;
        data["followUpTimeFrom"] = this.followUpTimeFrom ? this.followUpTimeFrom.toISOString() : <any>null;
        data["followUpTimeTo"] = this.followUpTimeTo ? this.followUpTimeTo.toISOString() : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IFluidsAnswerRequest extends IAnswerRequest {
    fluidsAmountOfferedInMl: number;
    fluidsAmountConsumedInMl?: number | null;
    offeredAmountUnknown: boolean;
    offeredTimeUnknown: boolean;
    offeredRegistrationTime: moment.Moment;
    fluidType: string;
    requiresFollowUp: boolean;
    followUpTimeFrom: moment.Moment;
    followUpTimeTo: moment.Moment;
}

export class RegistrationResponse implements IRegistrationResponse {
    answers!: AnswerResponse[];
    comment!: string;
    createdAt!: moment.Moment;
    customerId!: string;
    formId!: string;
    formTitle!: string;
    observedAt!: moment.Moment;
    registrantId!: string;
    id!: string;
    residentId!: string;
    totalScore!: number;
    scoringEnabled!: boolean;

    constructor(data?: IRegistrationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.answers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(AnswerResponse.fromJS(item));
            }
            else {
                this.answers = <any>null;
            }
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.createdAt = _data["createdAt"] ? moment(_data["createdAt"].toString()) : <any>null;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : <any>null;
            this.formId = _data["formId"] !== undefined ? _data["formId"] : <any>null;
            this.formTitle = _data["formTitle"] !== undefined ? _data["formTitle"] : <any>null;
            this.observedAt = _data["observedAt"] ? moment(_data["observedAt"].toString()) : <any>null;
            this.registrantId = _data["registrantId"] !== undefined ? _data["registrantId"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.residentId = _data["residentId"] !== undefined ? _data["residentId"] : <any>null;
            this.totalScore = _data["totalScore"] !== undefined ? _data["totalScore"] : <any>null;
            this.scoringEnabled = _data["scoringEnabled"] !== undefined ? _data["scoringEnabled"] : <any>null;
        }
    }

    static fromJS(data: any): RegistrationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["customerId"] = this.customerId !== undefined ? this.customerId : <any>null;
        data["formId"] = this.formId !== undefined ? this.formId : <any>null;
        data["formTitle"] = this.formTitle !== undefined ? this.formTitle : <any>null;
        data["observedAt"] = this.observedAt ? this.observedAt.toISOString() : <any>null;
        data["registrantId"] = this.registrantId !== undefined ? this.registrantId : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["residentId"] = this.residentId !== undefined ? this.residentId : <any>null;
        data["totalScore"] = this.totalScore !== undefined ? this.totalScore : <any>null;
        data["scoringEnabled"] = this.scoringEnabled !== undefined ? this.scoringEnabled : <any>null;
        return data; 
    }
}

export interface IRegistrationResponse {
    answers: AnswerResponse[];
    comment: string;
    createdAt: moment.Moment;
    customerId: string;
    formId: string;
    formTitle: string;
    observedAt: moment.Moment;
    registrantId: string;
    id: string;
    residentId: string;
    totalScore: number;
    scoringEnabled: boolean;
}

export class DeleteRegistrationRequest implements IDeleteRegistrationRequest {
    reason!: string;

    constructor(data?: IDeleteRegistrationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"] !== undefined ? _data["reason"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteRegistrationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRegistrationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason !== undefined ? this.reason : <any>null;
        return data; 
    }
}

export interface IDeleteRegistrationRequest {
    reason: string;
}

export class RegistrationWithoutAnswersResponse implements IRegistrationWithoutAnswersResponse {
    comment!: string;
    createdAt!: moment.Moment;
    customerId!: string;
    formId!: string;
    formTitle!: string;
    observedAt!: moment.Moment;
    registrantId!: string;
    id!: string;
    residentId!: string;
    totalScore!: number;

    constructor(data?: IRegistrationWithoutAnswersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.createdAt = _data["createdAt"] ? moment(_data["createdAt"].toString()) : <any>null;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : <any>null;
            this.formId = _data["formId"] !== undefined ? _data["formId"] : <any>null;
            this.formTitle = _data["formTitle"] !== undefined ? _data["formTitle"] : <any>null;
            this.observedAt = _data["observedAt"] ? moment(_data["observedAt"].toString()) : <any>null;
            this.registrantId = _data["registrantId"] !== undefined ? _data["registrantId"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.residentId = _data["residentId"] !== undefined ? _data["residentId"] : <any>null;
            this.totalScore = _data["totalScore"] !== undefined ? _data["totalScore"] : <any>null;
        }
    }

    static fromJS(data: any): RegistrationWithoutAnswersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationWithoutAnswersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["customerId"] = this.customerId !== undefined ? this.customerId : <any>null;
        data["formId"] = this.formId !== undefined ? this.formId : <any>null;
        data["formTitle"] = this.formTitle !== undefined ? this.formTitle : <any>null;
        data["observedAt"] = this.observedAt ? this.observedAt.toISOString() : <any>null;
        data["registrantId"] = this.registrantId !== undefined ? this.registrantId : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["residentId"] = this.residentId !== undefined ? this.residentId : <any>null;
        data["totalScore"] = this.totalScore !== undefined ? this.totalScore : <any>null;
        return data; 
    }
}

export interface IRegistrationWithoutAnswersResponse {
    comment: string;
    createdAt: moment.Moment;
    customerId: string;
    formId: string;
    formTitle: string;
    observedAt: moment.Moment;
    registrantId: string;
    id: string;
    residentId: string;
    totalScore: number;
}

export class GetRegistrationsRequest implements IGetRegistrationsRequest {
    formIds!: string[];
    fromDate!: moment.Moment;
    residentIds!: string[];
    toDate!: moment.Moment;

    constructor(data?: IGetRegistrationsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.formIds = [];
            this.residentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["formIds"])) {
                this.formIds = [] as any;
                for (let item of _data["formIds"])
                    this.formIds!.push(item);
            }
            else {
                this.formIds = <any>null;
            }
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>null;
            if (Array.isArray(_data["residentIds"])) {
                this.residentIds = [] as any;
                for (let item of _data["residentIds"])
                    this.residentIds!.push(item);
            }
            else {
                this.residentIds = <any>null;
            }
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): GetRegistrationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegistrationsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.formIds)) {
            data["formIds"] = [];
            for (let item of this.formIds)
                data["formIds"].push(item);
        }
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>null;
        if (Array.isArray(this.residentIds)) {
            data["residentIds"] = [];
            for (let item of this.residentIds)
                data["residentIds"].push(item);
        }
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>null;
        return data; 
    }
}

export interface IGetRegistrationsRequest {
    formIds: string[];
    fromDate: moment.Moment;
    residentIds: string[];
    toDate: moment.Moment;
}

export class GetRegistrationsWithFilterRequest implements IGetRegistrationsWithFilterRequest {
    formFilter!: FormFilterRequest;
    locationIds!: string[];
    from!: moment.Moment;
    to!: moment.Moment;
    countToTake?: number | null;

    constructor(data?: IGetRegistrationsWithFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.formFilter = new FormFilterRequest();
            this.locationIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formFilter = _data["formFilter"] ? FormFilterRequest.fromJS(_data["formFilter"]) : new FormFilterRequest();
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
            else {
                this.locationIds = <any>null;
            }
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>null;
            this.to = _data["to"] ? moment(_data["to"].toString()) : <any>null;
            this.countToTake = _data["countToTake"] !== undefined ? _data["countToTake"] : <any>null;
        }
    }

    static fromJS(data: any): GetRegistrationsWithFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegistrationsWithFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formFilter"] = this.formFilter ? this.formFilter.toJSON() : <any>null;
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        data["from"] = this.from ? this.from.toISOString() : <any>null;
        data["to"] = this.to ? this.to.toISOString() : <any>null;
        data["countToTake"] = this.countToTake !== undefined ? this.countToTake : <any>null;
        return data; 
    }
}

export interface IGetRegistrationsWithFilterRequest {
    formFilter: FormFilterRequest;
    locationIds: string[];
    from: moment.Moment;
    to: moment.Moment;
    countToTake?: number | null;
}

export class FormFilterRequest implements IFormFilterRequest {
    formId!: string;
    filterComponents!: FormFilterComponentRequest[];

    constructor(data?: IFormFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.filterComponents = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"] !== undefined ? _data["formId"] : <any>null;
            if (Array.isArray(_data["filterComponents"])) {
                this.filterComponents = [] as any;
                for (let item of _data["filterComponents"])
                    this.filterComponents!.push(FormFilterComponentRequest.fromJS(item));
            }
            else {
                this.filterComponents = <any>null;
            }
        }
    }

    static fromJS(data: any): FormFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FormFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId !== undefined ? this.formId : <any>null;
        if (Array.isArray(this.filterComponents)) {
            data["filterComponents"] = [];
            for (let item of this.filterComponents)
                data["filterComponents"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IFormFilterRequest {
    formId: string;
    filterComponents: FormFilterComponentRequest[];
}

export class FormFilterComponentRequest implements IFormFilterComponentRequest {
    operator!: Operator;
    condition!: Condition;
    value!: FilterValueRequest;
    stepId!: string;

    constructor(data?: IFormFilterComponentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operator = _data["operator"] !== undefined ? _data["operator"] : <any>null;
            this.condition = _data["condition"] !== undefined ? _data["condition"] : <any>null;
            this.value = _data["value"] ? FilterValueRequest.fromJS(_data["value"]) : <any>null;
            this.stepId = _data["stepId"] !== undefined ? _data["stepId"] : <any>null;
        }
    }

    static fromJS(data: any): FormFilterComponentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FormFilterComponentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operator"] = this.operator !== undefined ? this.operator : <any>null;
        data["condition"] = this.condition !== undefined ? this.condition : <any>null;
        data["value"] = this.value ? this.value.toJSON() : <any>null;
        data["stepId"] = this.stepId !== undefined ? this.stepId : <any>null;
        return data; 
    }
}

export interface IFormFilterComponentRequest {
    operator: Operator;
    condition: Condition;
    value: FilterValueRequest;
    stepId: string;
}

export enum Operator {
    And = "And",
    Or = "Or",
}

export enum Condition {
    Equals = "Equals",
    NotEquals = "NotEquals",
    LessThan = "LessThan",
    GreaterThan = "GreaterThan",
    LessThanOrEqual = "LessThanOrEqual",
    GreaterThanOrEqual = "GreaterThanOrEqual",
    StringContains = "StringContains",
    AnyOf = "AnyOf",
    AllOf = "AllOf",
}

export abstract class FilterValueRequest implements IFilterValueRequest {

    protected _discriminator: string;

    constructor(data?: IFilterValueRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "FilterValueRequest";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): FilterValueRequest {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "MultipleChoiceFormAnswerFilterValueRequest") {
            let result = new MultipleChoiceFormAnswerFilterValueRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HealthMeasurementDiastolicBloodPressureFilterValueRequest") {
            let result = new HealthMeasurementDiastolicBloodPressureFilterValueRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HealthMeasurementSystolicBloodPressureFilterValueRequest") {
            let result = new HealthMeasurementSystolicBloodPressureFilterValueRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HealthMeasurementBloodGlucoseFilterValueRequest") {
            let result = new HealthMeasurementBloodGlucoseFilterValueRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HealthMeasurementBodyTemperatureFilterValueRequest") {
            let result = new HealthMeasurementBodyTemperatureFilterValueRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HealthMeasurementBodyWeightFilterValueRequest") {
            let result = new HealthMeasurementBodyWeightFilterValueRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HealthMeasurementHeartRateFilterValueRequest") {
            let result = new HealthMeasurementHeartRateFilterValueRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HealthMeasurementOxygenSaturationFilterValueRequest") {
            let result = new HealthMeasurementOxygenSaturationFilterValueRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HealthMeasurementRespiratoryRateFilterValueRequest") {
            let result = new HealthMeasurementRespiratoryRateFilterValueRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HealthMeasurementHeightFilterValueRequest") {
            let result = new HealthMeasurementHeightFilterValueRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "NumericFormAnswerFilterValueRequest") {
            let result = new NumericFormAnswerFilterValueRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "FluidConsumedFormAnswerFilterValueRequest") {
            let result = new FluidConsumedFormAnswerFilterValueRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "FluidOfferedFormAnswerFilterValueRequest") {
            let result = new FluidOfferedFormAnswerFilterValueRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "CalculationFormAnswerFilterValueRequest") {
            let result = new CalculationFormAnswerFilterValueRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "FreeTextFormAnswerFilterValueRequest") {
            let result = new FreeTextFormAnswerFilterValueRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "QuestionScoreSumFormAnswerFilterValueRequest") {
            let result = new QuestionScoreSumFormAnswerFilterValueRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "FormScoreSumFormAnswerFilterValueRequest") {
            let result = new FormScoreSumFormAnswerFilterValueRequest();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'FilterValueRequest' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator; 
        return data; 
    }
}

export interface IFilterValueRequest {
}

export class MultipleChoiceFormAnswerFilterValueRequest extends FilterValueRequest implements IMultipleChoiceFormAnswerFilterValueRequest {
    value!: string[];

    constructor(data?: IMultipleChoiceFormAnswerFilterValueRequest) {
        super(data);
        if (!data) {
            this.value = [];
        }
        this._discriminator = "MultipleChoiceFormAnswerFilterValueRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(item);
            }
            else {
                this.value = <any>null;
            }
        }
    }

    static fromJS(data: any): MultipleChoiceFormAnswerFilterValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MultipleChoiceFormAnswerFilterValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IMultipleChoiceFormAnswerFilterValueRequest extends IFilterValueRequest {
    value: string[];
}

export class HealthMeasurementDiastolicBloodPressureFilterValueRequest extends FilterValueRequest implements IHealthMeasurementDiastolicBloodPressureFilterValueRequest {
    value!: number;

    constructor(data?: IHealthMeasurementDiastolicBloodPressureFilterValueRequest) {
        super(data);
        this._discriminator = "HealthMeasurementDiastolicBloodPressureFilterValueRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): HealthMeasurementDiastolicBloodPressureFilterValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HealthMeasurementDiastolicBloodPressureFilterValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IHealthMeasurementDiastolicBloodPressureFilterValueRequest extends IFilterValueRequest {
    value: number;
}

export class HealthMeasurementSystolicBloodPressureFilterValueRequest extends FilterValueRequest implements IHealthMeasurementSystolicBloodPressureFilterValueRequest {
    value!: number;

    constructor(data?: IHealthMeasurementSystolicBloodPressureFilterValueRequest) {
        super(data);
        this._discriminator = "HealthMeasurementSystolicBloodPressureFilterValueRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): HealthMeasurementSystolicBloodPressureFilterValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HealthMeasurementSystolicBloodPressureFilterValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IHealthMeasurementSystolicBloodPressureFilterValueRequest extends IFilterValueRequest {
    value: number;
}

export class HealthMeasurementBloodGlucoseFilterValueRequest extends FilterValueRequest implements IHealthMeasurementBloodGlucoseFilterValueRequest {
    value!: number;

    constructor(data?: IHealthMeasurementBloodGlucoseFilterValueRequest) {
        super(data);
        this._discriminator = "HealthMeasurementBloodGlucoseFilterValueRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): HealthMeasurementBloodGlucoseFilterValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HealthMeasurementBloodGlucoseFilterValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IHealthMeasurementBloodGlucoseFilterValueRequest extends IFilterValueRequest {
    value: number;
}

export class HealthMeasurementBodyTemperatureFilterValueRequest extends FilterValueRequest implements IHealthMeasurementBodyTemperatureFilterValueRequest {
    value!: number;

    constructor(data?: IHealthMeasurementBodyTemperatureFilterValueRequest) {
        super(data);
        this._discriminator = "HealthMeasurementBodyTemperatureFilterValueRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): HealthMeasurementBodyTemperatureFilterValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HealthMeasurementBodyTemperatureFilterValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IHealthMeasurementBodyTemperatureFilterValueRequest extends IFilterValueRequest {
    value: number;
}

export class HealthMeasurementBodyWeightFilterValueRequest extends FilterValueRequest implements IHealthMeasurementBodyWeightFilterValueRequest {
    value!: number;

    constructor(data?: IHealthMeasurementBodyWeightFilterValueRequest) {
        super(data);
        this._discriminator = "HealthMeasurementBodyWeightFilterValueRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): HealthMeasurementBodyWeightFilterValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HealthMeasurementBodyWeightFilterValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IHealthMeasurementBodyWeightFilterValueRequest extends IFilterValueRequest {
    value: number;
}

export class HealthMeasurementHeartRateFilterValueRequest extends FilterValueRequest implements IHealthMeasurementHeartRateFilterValueRequest {
    value!: number;

    constructor(data?: IHealthMeasurementHeartRateFilterValueRequest) {
        super(data);
        this._discriminator = "HealthMeasurementHeartRateFilterValueRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): HealthMeasurementHeartRateFilterValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HealthMeasurementHeartRateFilterValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IHealthMeasurementHeartRateFilterValueRequest extends IFilterValueRequest {
    value: number;
}

export class HealthMeasurementOxygenSaturationFilterValueRequest extends FilterValueRequest implements IHealthMeasurementOxygenSaturationFilterValueRequest {
    value!: number;

    constructor(data?: IHealthMeasurementOxygenSaturationFilterValueRequest) {
        super(data);
        this._discriminator = "HealthMeasurementOxygenSaturationFilterValueRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): HealthMeasurementOxygenSaturationFilterValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HealthMeasurementOxygenSaturationFilterValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IHealthMeasurementOxygenSaturationFilterValueRequest extends IFilterValueRequest {
    value: number;
}

export class HealthMeasurementRespiratoryRateFilterValueRequest extends FilterValueRequest implements IHealthMeasurementRespiratoryRateFilterValueRequest {
    value!: number;

    constructor(data?: IHealthMeasurementRespiratoryRateFilterValueRequest) {
        super(data);
        this._discriminator = "HealthMeasurementRespiratoryRateFilterValueRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): HealthMeasurementRespiratoryRateFilterValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HealthMeasurementRespiratoryRateFilterValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IHealthMeasurementRespiratoryRateFilterValueRequest extends IFilterValueRequest {
    value: number;
}

export class HealthMeasurementHeightFilterValueRequest extends FilterValueRequest implements IHealthMeasurementHeightFilterValueRequest {
    value!: number;

    constructor(data?: IHealthMeasurementHeightFilterValueRequest) {
        super(data);
        this._discriminator = "HealthMeasurementHeightFilterValueRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): HealthMeasurementHeightFilterValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HealthMeasurementHeightFilterValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IHealthMeasurementHeightFilterValueRequest extends IFilterValueRequest {
    value: number;
}

export class NumericFormAnswerFilterValueRequest extends FilterValueRequest implements INumericFormAnswerFilterValueRequest {
    value!: number;

    constructor(data?: INumericFormAnswerFilterValueRequest) {
        super(data);
        this._discriminator = "NumericFormAnswerFilterValueRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): NumericFormAnswerFilterValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NumericFormAnswerFilterValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface INumericFormAnswerFilterValueRequest extends IFilterValueRequest {
    value: number;
}

export class FluidConsumedFormAnswerFilterValueRequest extends FilterValueRequest implements IFluidConsumedFormAnswerFilterValueRequest {
    value!: number;

    constructor(data?: IFluidConsumedFormAnswerFilterValueRequest) {
        super(data);
        this._discriminator = "FluidConsumedFormAnswerFilterValueRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): FluidConsumedFormAnswerFilterValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FluidConsumedFormAnswerFilterValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IFluidConsumedFormAnswerFilterValueRequest extends IFilterValueRequest {
    value: number;
}

export class FluidOfferedFormAnswerFilterValueRequest extends FilterValueRequest implements IFluidOfferedFormAnswerFilterValueRequest {
    value!: number;

    constructor(data?: IFluidOfferedFormAnswerFilterValueRequest) {
        super(data);
        this._discriminator = "FluidOfferedFormAnswerFilterValueRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): FluidOfferedFormAnswerFilterValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FluidOfferedFormAnswerFilterValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IFluidOfferedFormAnswerFilterValueRequest extends IFilterValueRequest {
    value: number;
}

export class CalculationFormAnswerFilterValueRequest extends FilterValueRequest implements ICalculationFormAnswerFilterValueRequest {
    value!: number;

    constructor(data?: ICalculationFormAnswerFilterValueRequest) {
        super(data);
        this._discriminator = "CalculationFormAnswerFilterValueRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): CalculationFormAnswerFilterValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationFormAnswerFilterValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface ICalculationFormAnswerFilterValueRequest extends IFilterValueRequest {
    value: number;
}

export class FreeTextFormAnswerFilterValueRequest extends FilterValueRequest implements IFreeTextFormAnswerFilterValueRequest {
    value!: string;

    constructor(data?: IFreeTextFormAnswerFilterValueRequest) {
        super(data);
        this._discriminator = "FreeTextFormAnswerFilterValueRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): FreeTextFormAnswerFilterValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FreeTextFormAnswerFilterValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IFreeTextFormAnswerFilterValueRequest extends IFilterValueRequest {
    value: string;
}

export class QuestionScoreSumFormAnswerFilterValueRequest extends FilterValueRequest implements IQuestionScoreSumFormAnswerFilterValueRequest {
    value!: number;

    constructor(data?: IQuestionScoreSumFormAnswerFilterValueRequest) {
        super(data);
        this._discriminator = "QuestionScoreSumFormAnswerFilterValueRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): QuestionScoreSumFormAnswerFilterValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionScoreSumFormAnswerFilterValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IQuestionScoreSumFormAnswerFilterValueRequest extends IFilterValueRequest {
    value: number;
}

export class FormScoreSumFormAnswerFilterValueRequest extends FilterValueRequest implements IFormScoreSumFormAnswerFilterValueRequest {
    value!: number;

    constructor(data?: IFormScoreSumFormAnswerFilterValueRequest) {
        super(data);
        this._discriminator = "FormScoreSumFormAnswerFilterValueRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): FormScoreSumFormAnswerFilterValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FormScoreSumFormAnswerFilterValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IFormScoreSumFormAnswerFilterValueRequest extends IFilterValueRequest {
    value: number;
}

export class ResidentsWithNoRegistrationsForFormResponse implements IResidentsWithNoRegistrationsForFormResponse {
    formId!: string;
    residentIds!: string[];

    constructor(data?: IResidentsWithNoRegistrationsForFormResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.residentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"] !== undefined ? _data["formId"] : <any>null;
            if (Array.isArray(_data["residentIds"])) {
                this.residentIds = [] as any;
                for (let item of _data["residentIds"])
                    this.residentIds!.push(item);
            }
            else {
                this.residentIds = <any>null;
            }
        }
    }

    static fromJS(data: any): ResidentsWithNoRegistrationsForFormResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResidentsWithNoRegistrationsForFormResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId !== undefined ? this.formId : <any>null;
        if (Array.isArray(this.residentIds)) {
            data["residentIds"] = [];
            for (let item of this.residentIds)
                data["residentIds"].push(item);
        }
        return data; 
    }
}

export interface IResidentsWithNoRegistrationsForFormResponse {
    formId: string;
    residentIds: string[];
}

export class GetRegistrationsReportRequest implements IGetRegistrationsReportRequest {
    formIds!: string[];
    fromDate!: moment.Moment;
    residentIds!: string[];
    toDate!: moment.Moment;

    constructor(data?: IGetRegistrationsReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.formIds = [];
            this.residentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["formIds"])) {
                this.formIds = [] as any;
                for (let item of _data["formIds"])
                    this.formIds!.push(item);
            }
            else {
                this.formIds = <any>null;
            }
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>null;
            if (Array.isArray(_data["residentIds"])) {
                this.residentIds = [] as any;
                for (let item of _data["residentIds"])
                    this.residentIds!.push(item);
            }
            else {
                this.residentIds = <any>null;
            }
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): GetRegistrationsReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegistrationsReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.formIds)) {
            data["formIds"] = [];
            for (let item of this.formIds)
                data["formIds"].push(item);
        }
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>null;
        if (Array.isArray(this.residentIds)) {
            data["residentIds"] = [];
            for (let item of this.residentIds)
                data["residentIds"].push(item);
        }
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>null;
        return data; 
    }
}

export interface IGetRegistrationsReportRequest {
    formIds: string[];
    fromDate: moment.Moment;
    residentIds: string[];
    toDate: moment.Moment;
}

export class FolderResponse implements IFolderResponse {
    id!: string;
    name!: string;
    ownerId!: string;
    customerId!: string;

    constructor(data?: IFolderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.ownerId = _data["ownerId"] !== undefined ? _data["ownerId"] : <any>null;
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : <any>null;
        }
    }

    static fromJS(data: any): FolderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FolderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["ownerId"] = this.ownerId !== undefined ? this.ownerId : <any>null;
        data["customerId"] = this.customerId !== undefined ? this.customerId : <any>null;
        return data; 
    }
}

export interface IFolderResponse {
    id: string;
    name: string;
    ownerId: string;
    customerId: string;
}

export class FormResponse implements IFormResponse {
    archived!: boolean;
    description?: string | null;
    id!: string;
    ownerId!: string;
    title!: string;
    descriptiveImagePath?: string | null;
    accessControlTagIds!: string[];
    folderId?: string | null;

    constructor(data?: IFormResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.accessControlTagIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.archived = _data["archived"] !== undefined ? _data["archived"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.ownerId = _data["ownerId"] !== undefined ? _data["ownerId"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.descriptiveImagePath = _data["descriptiveImagePath"] !== undefined ? _data["descriptiveImagePath"] : <any>null;
            if (Array.isArray(_data["accessControlTagIds"])) {
                this.accessControlTagIds = [] as any;
                for (let item of _data["accessControlTagIds"])
                    this.accessControlTagIds!.push(item);
            }
            else {
                this.accessControlTagIds = <any>null;
            }
            this.folderId = _data["folderId"] !== undefined ? _data["folderId"] : <any>null;
        }
    }

    static fromJS(data: any): FormResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FormResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["archived"] = this.archived !== undefined ? this.archived : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["ownerId"] = this.ownerId !== undefined ? this.ownerId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["descriptiveImagePath"] = this.descriptiveImagePath !== undefined ? this.descriptiveImagePath : <any>null;
        if (Array.isArray(this.accessControlTagIds)) {
            data["accessControlTagIds"] = [];
            for (let item of this.accessControlTagIds)
                data["accessControlTagIds"].push(item);
        }
        data["folderId"] = this.folderId !== undefined ? this.folderId : <any>null;
        return data; 
    }
}

export interface IFormResponse {
    archived: boolean;
    description?: string | null;
    id: string;
    ownerId: string;
    title: string;
    descriptiveImagePath?: string | null;
    accessControlTagIds: string[];
    folderId?: string | null;
}

export class GetFormsForOwnersBatchRequest implements IGetFormsForOwnersBatchRequest {
    includeArchived!: boolean;
    ownerIds!: string[];

    constructor(data?: IGetFormsForOwnersBatchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ownerIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.includeArchived = _data["includeArchived"] !== undefined ? _data["includeArchived"] : <any>null;
            if (Array.isArray(_data["ownerIds"])) {
                this.ownerIds = [] as any;
                for (let item of _data["ownerIds"])
                    this.ownerIds!.push(item);
            }
            else {
                this.ownerIds = <any>null;
            }
        }
    }

    static fromJS(data: any): GetFormsForOwnersBatchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFormsForOwnersBatchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includeArchived"] = this.includeArchived !== undefined ? this.includeArchived : <any>null;
        if (Array.isArray(this.ownerIds)) {
            data["ownerIds"] = [];
            for (let item of this.ownerIds)
                data["ownerIds"].push(item);
        }
        return data; 
    }
}

export interface IGetFormsForOwnersBatchRequest {
    includeArchived: boolean;
    ownerIds: string[];
}

export class GetFormsForOwnersBatchInternalRequest extends GetFormsForOwnersBatchRequest implements IGetFormsForOwnersBatchInternalRequest {
    customerId!: string;

    constructor(data?: IGetFormsForOwnersBatchInternalRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : <any>null;
        }
    }

    static fromJS(data: any): GetFormsForOwnersBatchInternalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFormsForOwnersBatchInternalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId !== undefined ? this.customerId : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IGetFormsForOwnersBatchInternalRequest extends IGetFormsForOwnersBatchRequest {
    customerId: string;
}

export class CopyFoldersAndContentRequest implements ICopyFoldersAndContentRequest {
    sourceCustomerId!: string;
    destinationCustomerId!: string;
    destinationOwnerId!: string;
    folderIds!: string[];

    constructor(data?: ICopyFoldersAndContentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.folderIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceCustomerId = _data["sourceCustomerId"] !== undefined ? _data["sourceCustomerId"] : <any>null;
            this.destinationCustomerId = _data["destinationCustomerId"] !== undefined ? _data["destinationCustomerId"] : <any>null;
            this.destinationOwnerId = _data["destinationOwnerId"] !== undefined ? _data["destinationOwnerId"] : <any>null;
            if (Array.isArray(_data["folderIds"])) {
                this.folderIds = [] as any;
                for (let item of _data["folderIds"])
                    this.folderIds!.push(item);
            }
            else {
                this.folderIds = <any>null;
            }
        }
    }

    static fromJS(data: any): CopyFoldersAndContentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopyFoldersAndContentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceCustomerId"] = this.sourceCustomerId !== undefined ? this.sourceCustomerId : <any>null;
        data["destinationCustomerId"] = this.destinationCustomerId !== undefined ? this.destinationCustomerId : <any>null;
        data["destinationOwnerId"] = this.destinationOwnerId !== undefined ? this.destinationOwnerId : <any>null;
        if (Array.isArray(this.folderIds)) {
            data["folderIds"] = [];
            for (let item of this.folderIds)
                data["folderIds"].push(item);
        }
        return data; 
    }
}

export interface ICopyFoldersAndContentRequest {
    sourceCustomerId: string;
    destinationCustomerId: string;
    destinationOwnerId: string;
    folderIds: string[];
}

export class CopyFormsRequest implements ICopyFormsRequest {
    sourceCustomerId!: string;
    destinationCustomerId!: string;
    destinationOwnerId!: string;
    formIds!: string[];

    constructor(data?: ICopyFormsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.formIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceCustomerId = _data["sourceCustomerId"] !== undefined ? _data["sourceCustomerId"] : <any>null;
            this.destinationCustomerId = _data["destinationCustomerId"] !== undefined ? _data["destinationCustomerId"] : <any>null;
            this.destinationOwnerId = _data["destinationOwnerId"] !== undefined ? _data["destinationOwnerId"] : <any>null;
            if (Array.isArray(_data["formIds"])) {
                this.formIds = [] as any;
                for (let item of _data["formIds"])
                    this.formIds!.push(item);
            }
            else {
                this.formIds = <any>null;
            }
        }
    }

    static fromJS(data: any): CopyFormsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopyFormsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceCustomerId"] = this.sourceCustomerId !== undefined ? this.sourceCustomerId : <any>null;
        data["destinationCustomerId"] = this.destinationCustomerId !== undefined ? this.destinationCustomerId : <any>null;
        data["destinationOwnerId"] = this.destinationOwnerId !== undefined ? this.destinationOwnerId : <any>null;
        if (Array.isArray(this.formIds)) {
            data["formIds"] = [];
            for (let item of this.formIds)
                data["formIds"].push(item);
        }
        return data; 
    }
}

export interface ICopyFormsRequest {
    sourceCustomerId: string;
    destinationCustomerId: string;
    destinationOwnerId: string;
    formIds: string[];
}

export class CreateFormIdResponse implements ICreateFormIdResponse {
    formId!: string;

    constructor(data?: ICreateFormIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"] !== undefined ? _data["formId"] : <any>null;
        }
    }

    static fromJS(data: any): CreateFormIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFormIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId !== undefined ? this.formId : <any>null;
        return data; 
    }
}

export interface ICreateFormIdResponse {
    formId: string;
}

export class CreateFormRequest implements ICreateFormRequest {
    ownerId!: string;
    title!: string;

    constructor(data?: ICreateFormRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerId = _data["ownerId"] !== undefined ? _data["ownerId"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
        }
    }

    static fromJS(data: any): CreateFormRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFormRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerId"] = this.ownerId !== undefined ? this.ownerId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        return data; 
    }
}

export interface ICreateFormRequest {
    ownerId: string;
    title: string;
}

export class PlanAssociationResponse implements IPlanAssociationResponse {
    planId!: string;
    residentId!: string;

    constructor(data?: IPlanAssociationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.planId = _data["planId"] !== undefined ? _data["planId"] : <any>null;
            this.residentId = _data["residentId"] !== undefined ? _data["residentId"] : <any>null;
        }
    }

    static fromJS(data: any): PlanAssociationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlanAssociationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planId"] = this.planId !== undefined ? this.planId : <any>null;
        data["residentId"] = this.residentId !== undefined ? this.residentId : <any>null;
        return data; 
    }
}

export interface IPlanAssociationResponse {
    planId: string;
    residentId: string;
}

export class PlanFormAssociationResponse implements IPlanFormAssociationResponse {
    planId!: string;
    forms!: FormResponse[];

    constructor(data?: IPlanFormAssociationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.forms = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.planId = _data["planId"] !== undefined ? _data["planId"] : <any>null;
            if (Array.isArray(_data["forms"])) {
                this.forms = [] as any;
                for (let item of _data["forms"])
                    this.forms!.push(FormResponse.fromJS(item));
            }
            else {
                this.forms = <any>null;
            }
        }
    }

    static fromJS(data: any): PlanFormAssociationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlanFormAssociationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planId"] = this.planId !== undefined ? this.planId : <any>null;
        if (Array.isArray(this.forms)) {
            data["forms"] = [];
            for (let item of this.forms)
                data["forms"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPlanFormAssociationResponse {
    planId: string;
    forms: FormResponse[];
}

export class GetFormsByResidentAndPlansBatchRequest implements IGetFormsByResidentAndPlansBatchRequest {
    planIds!: string[];

    constructor(data?: IGetFormsByResidentAndPlansBatchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.planIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["planIds"])) {
                this.planIds = [] as any;
                for (let item of _data["planIds"])
                    this.planIds!.push(item);
            }
            else {
                this.planIds = <any>null;
            }
        }
    }

    static fromJS(data: any): GetFormsByResidentAndPlansBatchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFormsByResidentAndPlansBatchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.planIds)) {
            data["planIds"] = [];
            for (let item of this.planIds)
                data["planIds"].push(item);
        }
        return data; 
    }
}

export interface IGetFormsByResidentAndPlansBatchRequest {
    planIds: string[];
}

export class FormStepResponse implements IFormStepResponse {
    paused!: boolean;
    archived!: boolean;
    description?: string | null;
    id!: string;
    ownerId!: string;
    steps!: StepResponse[];
    title!: string;
    residentId!: string;
    includeRegistrationInRecords!: boolean;
    descriptiveImagePath?: string | null;
    accessControlTagIds!: string[];
    folderId?: string | null;

    constructor(data?: IFormStepResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.steps = [];
            this.accessControlTagIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paused = _data["paused"] !== undefined ? _data["paused"] : <any>null;
            this.archived = _data["archived"] !== undefined ? _data["archived"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.ownerId = _data["ownerId"] !== undefined ? _data["ownerId"] : <any>null;
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(StepResponse.fromJS(item));
            }
            else {
                this.steps = <any>null;
            }
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.residentId = _data["residentId"] !== undefined ? _data["residentId"] : <any>null;
            this.includeRegistrationInRecords = _data["includeRegistrationInRecords"] !== undefined ? _data["includeRegistrationInRecords"] : <any>null;
            this.descriptiveImagePath = _data["descriptiveImagePath"] !== undefined ? _data["descriptiveImagePath"] : <any>null;
            if (Array.isArray(_data["accessControlTagIds"])) {
                this.accessControlTagIds = [] as any;
                for (let item of _data["accessControlTagIds"])
                    this.accessControlTagIds!.push(item);
            }
            else {
                this.accessControlTagIds = <any>null;
            }
            this.folderId = _data["folderId"] !== undefined ? _data["folderId"] : <any>null;
        }
    }

    static fromJS(data: any): FormStepResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FormStepResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paused"] = this.paused !== undefined ? this.paused : <any>null;
        data["archived"] = this.archived !== undefined ? this.archived : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["ownerId"] = this.ownerId !== undefined ? this.ownerId : <any>null;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item.toJSON());
        }
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["residentId"] = this.residentId !== undefined ? this.residentId : <any>null;
        data["includeRegistrationInRecords"] = this.includeRegistrationInRecords !== undefined ? this.includeRegistrationInRecords : <any>null;
        data["descriptiveImagePath"] = this.descriptiveImagePath !== undefined ? this.descriptiveImagePath : <any>null;
        if (Array.isArray(this.accessControlTagIds)) {
            data["accessControlTagIds"] = [];
            for (let item of this.accessControlTagIds)
                data["accessControlTagIds"].push(item);
        }
        data["folderId"] = this.folderId !== undefined ? this.folderId : <any>null;
        return data; 
    }
}

export interface IFormStepResponse {
    paused: boolean;
    archived: boolean;
    description?: string | null;
    id: string;
    ownerId: string;
    steps: StepResponse[];
    title: string;
    residentId: string;
    includeRegistrationInRecords: boolean;
    descriptiveImagePath?: string | null;
    accessControlTagIds: string[];
    folderId?: string | null;
}

export class FormAssignmentResponse implements IFormAssignmentResponse {
    paused!: boolean;
    activeForResident!: boolean;
    assignedToResidentId!: string;
    archived!: boolean;
    id!: string;
    ownerId!: string;
    residentExtendedStepCount!: number;
    title!: string;
    accessControlTagIds!: string[];
    folderId?: string | null;

    constructor(data?: IFormAssignmentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.accessControlTagIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paused = _data["paused"] !== undefined ? _data["paused"] : <any>null;
            this.activeForResident = _data["activeForResident"] !== undefined ? _data["activeForResident"] : <any>null;
            this.assignedToResidentId = _data["assignedToResidentId"] !== undefined ? _data["assignedToResidentId"] : <any>null;
            this.archived = _data["archived"] !== undefined ? _data["archived"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.ownerId = _data["ownerId"] !== undefined ? _data["ownerId"] : <any>null;
            this.residentExtendedStepCount = _data["residentExtendedStepCount"] !== undefined ? _data["residentExtendedStepCount"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            if (Array.isArray(_data["accessControlTagIds"])) {
                this.accessControlTagIds = [] as any;
                for (let item of _data["accessControlTagIds"])
                    this.accessControlTagIds!.push(item);
            }
            else {
                this.accessControlTagIds = <any>null;
            }
            this.folderId = _data["folderId"] !== undefined ? _data["folderId"] : <any>null;
        }
    }

    static fromJS(data: any): FormAssignmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FormAssignmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paused"] = this.paused !== undefined ? this.paused : <any>null;
        data["activeForResident"] = this.activeForResident !== undefined ? this.activeForResident : <any>null;
        data["assignedToResidentId"] = this.assignedToResidentId !== undefined ? this.assignedToResidentId : <any>null;
        data["archived"] = this.archived !== undefined ? this.archived : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["ownerId"] = this.ownerId !== undefined ? this.ownerId : <any>null;
        data["residentExtendedStepCount"] = this.residentExtendedStepCount !== undefined ? this.residentExtendedStepCount : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        if (Array.isArray(this.accessControlTagIds)) {
            data["accessControlTagIds"] = [];
            for (let item of this.accessControlTagIds)
                data["accessControlTagIds"].push(item);
        }
        data["folderId"] = this.folderId !== undefined ? this.folderId : <any>null;
        return data; 
    }
}

export interface IFormAssignmentResponse {
    paused: boolean;
    activeForResident: boolean;
    assignedToResidentId: string;
    archived: boolean;
    id: string;
    ownerId: string;
    residentExtendedStepCount: number;
    title: string;
    accessControlTagIds: string[];
    folderId?: string | null;
}

export class GetFormsWithAssignmentsIncludedByQueryBodyRequest implements IGetFormsWithAssignmentsIncludedByQueryBodyRequest {
    includeArchived!: boolean;
    residentIds!: string[];

    constructor(data?: IGetFormsWithAssignmentsIncludedByQueryBodyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.residentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.includeArchived = _data["includeArchived"] !== undefined ? _data["includeArchived"] : <any>null;
            if (Array.isArray(_data["residentIds"])) {
                this.residentIds = [] as any;
                for (let item of _data["residentIds"])
                    this.residentIds!.push(item);
            }
            else {
                this.residentIds = <any>null;
            }
        }
    }

    static fromJS(data: any): GetFormsWithAssignmentsIncludedByQueryBodyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFormsWithAssignmentsIncludedByQueryBodyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includeArchived"] = this.includeArchived !== undefined ? this.includeArchived : <any>null;
        if (Array.isArray(this.residentIds)) {
            data["residentIds"] = [];
            for (let item of this.residentIds)
                data["residentIds"].push(item);
        }
        return data; 
    }
}

export interface IGetFormsWithAssignmentsIncludedByQueryBodyRequest {
    includeArchived: boolean;
    residentIds: string[];
}

export class SetFormArchivedStatusRequest implements ISetFormArchivedStatusRequest {
    archived!: boolean;

    constructor(data?: ISetFormArchivedStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.archived = _data["archived"] !== undefined ? _data["archived"] : <any>null;
        }
    }

    static fromJS(data: any): SetFormArchivedStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetFormArchivedStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["archived"] = this.archived !== undefined ? this.archived : <any>null;
        return data; 
    }
}

export interface ISetFormArchivedStatusRequest {
    archived: boolean;
}

export class UpdateFormRequest implements IUpdateFormRequest {
    title!: string;
    description?: string | null;
    folderId?: string | null;
    descriptiveImage?: DescriptiveImage2 | null;
    accessControlTagIds!: string[];

    constructor(data?: IUpdateFormRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.accessControlTagIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.folderId = _data["folderId"] !== undefined ? _data["folderId"] : <any>null;
            this.descriptiveImage = _data["descriptiveImage"] ? DescriptiveImage2.fromJS(_data["descriptiveImage"]) : <any>null;
            if (Array.isArray(_data["accessControlTagIds"])) {
                this.accessControlTagIds = [] as any;
                for (let item of _data["accessControlTagIds"])
                    this.accessControlTagIds!.push(item);
            }
            else {
                this.accessControlTagIds = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateFormRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFormRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["folderId"] = this.folderId !== undefined ? this.folderId : <any>null;
        data["descriptiveImage"] = this.descriptiveImage ? this.descriptiveImage.toJSON() : <any>null;
        if (Array.isArray(this.accessControlTagIds)) {
            data["accessControlTagIds"] = [];
            for (let item of this.accessControlTagIds)
                data["accessControlTagIds"].push(item);
        }
        return data; 
    }
}

export interface IUpdateFormRequest {
    title: string;
    description?: string | null;
    folderId?: string | null;
    descriptiveImage?: DescriptiveImage2 | null;
    accessControlTagIds: string[];
}

export class DescriptiveImage2 implements IDescriptiveImage2 {
    imagePath?: string | null;
    imageData?: string | null;
    deleteImage?: boolean | null;

    constructor(data?: IDescriptiveImage2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imagePath = _data["imagePath"] !== undefined ? _data["imagePath"] : <any>null;
            this.imageData = _data["imageData"] !== undefined ? _data["imageData"] : <any>null;
            this.deleteImage = _data["deleteImage"] !== undefined ? _data["deleteImage"] : <any>null;
        }
    }

    static fromJS(data: any): DescriptiveImage2 {
        data = typeof data === 'object' ? data : {};
        let result = new DescriptiveImage2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imagePath"] = this.imagePath !== undefined ? this.imagePath : <any>null;
        data["imageData"] = this.imageData !== undefined ? this.imageData : <any>null;
        data["deleteImage"] = this.deleteImage !== undefined ? this.deleteImage : <any>null;
        return data; 
    }
}

export interface IDescriptiveImage2 {
    imagePath?: string | null;
    imageData?: string | null;
    deleteImage?: boolean | null;
}

export class SetFutureAssignmentsRequest implements ISetFutureAssignmentsRequest {
    assignedAndEnabledForEmployeesOnFutureResidents!: boolean;
    assignedAndEnabledForResidentsOnFutureResidents!: boolean;

    constructor(data?: ISetFutureAssignmentsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignedAndEnabledForEmployeesOnFutureResidents = _data["assignedAndEnabledForEmployeesOnFutureResidents"] !== undefined ? _data["assignedAndEnabledForEmployeesOnFutureResidents"] : <any>null;
            this.assignedAndEnabledForResidentsOnFutureResidents = _data["assignedAndEnabledForResidentsOnFutureResidents"] !== undefined ? _data["assignedAndEnabledForResidentsOnFutureResidents"] : <any>null;
        }
    }

    static fromJS(data: any): SetFutureAssignmentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetFutureAssignmentsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignedAndEnabledForEmployeesOnFutureResidents"] = this.assignedAndEnabledForEmployeesOnFutureResidents !== undefined ? this.assignedAndEnabledForEmployeesOnFutureResidents : <any>null;
        data["assignedAndEnabledForResidentsOnFutureResidents"] = this.assignedAndEnabledForResidentsOnFutureResidents !== undefined ? this.assignedAndEnabledForResidentsOnFutureResidents : <any>null;
        return data; 
    }
}

export interface ISetFutureAssignmentsRequest {
    assignedAndEnabledForEmployeesOnFutureResidents: boolean;
    assignedAndEnabledForResidentsOnFutureResidents: boolean;
}

export class AssignedForFutureResidentsResponse implements IAssignedForFutureResidentsResponse {
    assignedAndEnabledForEmployeesOnFutureResidents!: boolean;
    assignedAndEnabledForResidentsOnFutureResidents!: boolean;

    constructor(data?: IAssignedForFutureResidentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignedAndEnabledForEmployeesOnFutureResidents = _data["assignedAndEnabledForEmployeesOnFutureResidents"] !== undefined ? _data["assignedAndEnabledForEmployeesOnFutureResidents"] : <any>null;
            this.assignedAndEnabledForResidentsOnFutureResidents = _data["assignedAndEnabledForResidentsOnFutureResidents"] !== undefined ? _data["assignedAndEnabledForResidentsOnFutureResidents"] : <any>null;
        }
    }

    static fromJS(data: any): AssignedForFutureResidentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssignedForFutureResidentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignedAndEnabledForEmployeesOnFutureResidents"] = this.assignedAndEnabledForEmployeesOnFutureResidents !== undefined ? this.assignedAndEnabledForEmployeesOnFutureResidents : <any>null;
        data["assignedAndEnabledForResidentsOnFutureResidents"] = this.assignedAndEnabledForResidentsOnFutureResidents !== undefined ? this.assignedAndEnabledForResidentsOnFutureResidents : <any>null;
        return data; 
    }
}

export interface IAssignedForFutureResidentsResponse {
    assignedAndEnabledForEmployeesOnFutureResidents: boolean;
    assignedAndEnabledForResidentsOnFutureResidents: boolean;
}

export class UpdatePlanAndResidentRelationsRequest implements IUpdatePlanAndResidentRelationsRequest {
    formIdsToAdd!: string[];
    formIdsToRemove!: string[];

    constructor(data?: IUpdatePlanAndResidentRelationsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.formIdsToAdd = [];
            this.formIdsToRemove = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["formIdsToAdd"])) {
                this.formIdsToAdd = [] as any;
                for (let item of _data["formIdsToAdd"])
                    this.formIdsToAdd!.push(item);
            }
            else {
                this.formIdsToAdd = <any>null;
            }
            if (Array.isArray(_data["formIdsToRemove"])) {
                this.formIdsToRemove = [] as any;
                for (let item of _data["formIdsToRemove"])
                    this.formIdsToRemove!.push(item);
            }
            else {
                this.formIdsToRemove = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdatePlanAndResidentRelationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlanAndResidentRelationsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.formIdsToAdd)) {
            data["formIdsToAdd"] = [];
            for (let item of this.formIdsToAdd)
                data["formIdsToAdd"].push(item);
        }
        if (Array.isArray(this.formIdsToRemove)) {
            data["formIdsToRemove"] = [];
            for (let item of this.formIdsToRemove)
                data["formIdsToRemove"].push(item);
        }
        return data; 
    }
}

export interface IUpdatePlanAndResidentRelationsRequest {
    formIdsToAdd: string[];
    formIdsToRemove: string[];
}

export class UpdateNexusVumSubGoalAssociationsRequest implements IUpdateNexusVumSubGoalAssociationsRequest {
    formIdsToAdd!: string[];
    formIdsToRemove!: string[];

    constructor(data?: IUpdateNexusVumSubGoalAssociationsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.formIdsToAdd = [];
            this.formIdsToRemove = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["formIdsToAdd"])) {
                this.formIdsToAdd = [] as any;
                for (let item of _data["formIdsToAdd"])
                    this.formIdsToAdd!.push(item);
            }
            else {
                this.formIdsToAdd = <any>null;
            }
            if (Array.isArray(_data["formIdsToRemove"])) {
                this.formIdsToRemove = [] as any;
                for (let item of _data["formIdsToRemove"])
                    this.formIdsToRemove!.push(item);
            }
            else {
                this.formIdsToRemove = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateNexusVumSubGoalAssociationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNexusVumSubGoalAssociationsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.formIdsToAdd)) {
            data["formIdsToAdd"] = [];
            for (let item of this.formIdsToAdd)
                data["formIdsToAdd"].push(item);
        }
        if (Array.isArray(this.formIdsToRemove)) {
            data["formIdsToRemove"] = [];
            for (let item of this.formIdsToRemove)
                data["formIdsToRemove"].push(item);
        }
        return data; 
    }
}

export interface IUpdateNexusVumSubGoalAssociationsRequest {
    formIdsToAdd: string[];
    formIdsToRemove: string[];
}

export class FormNexusVumSubGoalAssociationResponse implements IFormNexusVumSubGoalAssociationResponse {
    nexusVumSubGoalId!: string;
    forms!: FormResponse[];

    constructor(data?: IFormNexusVumSubGoalAssociationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.forms = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nexusVumSubGoalId = _data["nexusVumSubGoalId"] !== undefined ? _data["nexusVumSubGoalId"] : <any>null;
            if (Array.isArray(_data["forms"])) {
                this.forms = [] as any;
                for (let item of _data["forms"])
                    this.forms!.push(FormResponse.fromJS(item));
            }
            else {
                this.forms = <any>null;
            }
        }
    }

    static fromJS(data: any): FormNexusVumSubGoalAssociationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FormNexusVumSubGoalAssociationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nexusVumSubGoalId"] = this.nexusVumSubGoalId !== undefined ? this.nexusVumSubGoalId : <any>null;
        if (Array.isArray(this.forms)) {
            data["forms"] = [];
            for (let item of this.forms)
                data["forms"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IFormNexusVumSubGoalAssociationResponse {
    nexusVumSubGoalId: string;
    forms: FormResponse[];
}

export class ResidentFormResponse implements IResidentFormResponse {
    notAssignedForms!: NotAssignedFormResponse[];
    assignedForms!: AssignedFormResponse[];

    constructor(data?: IResidentFormResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.notAssignedForms = [];
            this.assignedForms = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["notAssignedForms"])) {
                this.notAssignedForms = [] as any;
                for (let item of _data["notAssignedForms"])
                    this.notAssignedForms!.push(NotAssignedFormResponse.fromJS(item));
            }
            else {
                this.notAssignedForms = <any>null;
            }
            if (Array.isArray(_data["assignedForms"])) {
                this.assignedForms = [] as any;
                for (let item of _data["assignedForms"])
                    this.assignedForms!.push(AssignedFormResponse.fromJS(item));
            }
            else {
                this.assignedForms = <any>null;
            }
        }
    }

    static fromJS(data: any): ResidentFormResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResidentFormResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.notAssignedForms)) {
            data["notAssignedForms"] = [];
            for (let item of this.notAssignedForms)
                data["notAssignedForms"].push(item.toJSON());
        }
        if (Array.isArray(this.assignedForms)) {
            data["assignedForms"] = [];
            for (let item of this.assignedForms)
                data["assignedForms"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IResidentFormResponse {
    notAssignedForms: NotAssignedFormResponse[];
    assignedForms: AssignedFormResponse[];
}

export class NotAssignedFormResponse implements INotAssignedFormResponse {
    formId!: string;
    title!: string;
    archived!: boolean;

    constructor(data?: INotAssignedFormResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"] !== undefined ? _data["formId"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.archived = _data["archived"] !== undefined ? _data["archived"] : <any>null;
        }
    }

    static fromJS(data: any): NotAssignedFormResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NotAssignedFormResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId !== undefined ? this.formId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["archived"] = this.archived !== undefined ? this.archived : <any>null;
        return data; 
    }
}

export interface INotAssignedFormResponse {
    formId: string;
    title: string;
    archived: boolean;
}

export class AssignedFormResponse extends FormStepResponse implements IAssignedFormResponse {

    constructor(data?: IAssignedFormResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): AssignedFormResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssignedFormResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IAssignedFormResponse extends IFormStepResponse {
}

export class GetFormsByIdBatchRequest implements IGetFormsByIdBatchRequest {
    formIds!: string[];

    constructor(data?: IGetFormsByIdBatchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.formIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["formIds"])) {
                this.formIds = [] as any;
                for (let item of _data["formIds"])
                    this.formIds!.push(item);
            }
            else {
                this.formIds = <any>null;
            }
        }
    }

    static fromJS(data: any): GetFormsByIdBatchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFormsByIdBatchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.formIds)) {
            data["formIds"] = [];
            for (let item of this.formIds)
                data["formIds"].push(item);
        }
        return data; 
    }
}

export interface IGetFormsByIdBatchRequest {
    formIds: string[];
}

export class SetIncludeFormInRecordRequest implements ISetIncludeFormInRecordRequest {
    includeInRecords!: boolean;

    constructor(data?: ISetIncludeFormInRecordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.includeInRecords = _data["includeInRecords"] !== undefined ? _data["includeInRecords"] : <any>null;
        }
    }

    static fromJS(data: any): SetIncludeFormInRecordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetIncludeFormInRecordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includeInRecords"] = this.includeInRecords !== undefined ? this.includeInRecords : <any>null;
        return data; 
    }
}

export interface ISetIncludeFormInRecordRequest {
    includeInRecords: boolean;
}

export class CreateFolderRequest implements ICreateFolderRequest {
    ownerId!: string;
    name!: string;

    constructor(data?: ICreateFolderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerId = _data["ownerId"] !== undefined ? _data["ownerId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): CreateFolderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFolderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerId"] = this.ownerId !== undefined ? this.ownerId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data; 
    }
}

export interface ICreateFolderRequest {
    ownerId: string;
    name: string;
}

export class UpdateFolderRequest implements IUpdateFolderRequest {
    name!: string;

    constructor(data?: IUpdateFolderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateFolderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFolderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data; 
    }
}

export interface IUpdateFolderRequest {
    name: string;
}

export class CreateChoiceRequest implements ICreateChoiceRequest {
    imageData!: string;
    score!: number;
    title?: string | null;

    constructor(data?: ICreateChoiceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageData = _data["imageData"] !== undefined ? _data["imageData"] : <any>null;
            this.score = _data["score"] !== undefined ? _data["score"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
        }
    }

    static fromJS(data: any): CreateChoiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateChoiceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageData"] = this.imageData !== undefined ? this.imageData : <any>null;
        data["score"] = this.score !== undefined ? this.score : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        return data; 
    }
}

export interface ICreateChoiceRequest {
    imageData: string;
    score: number;
    title?: string | null;
}

export class UpdateChoicesRequest implements IUpdateChoicesRequest {
    choices!: ChoiceRequest[];

    constructor(data?: IUpdateChoicesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.choices = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["choices"])) {
                this.choices = [] as any;
                for (let item of _data["choices"])
                    this.choices!.push(ChoiceRequest.fromJS(item));
            }
            else {
                this.choices = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateChoicesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateChoicesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateChoicesRequest {
    choices: ChoiceRequest[];
}

export class ChoiceRequest implements IChoiceRequest {
    choiceId!: string;
    orderIndex!: number;
    score!: number;
    title!: string;

    constructor(data?: IChoiceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.choiceId = _data["choiceId"] !== undefined ? _data["choiceId"] : <any>null;
            this.orderIndex = _data["orderIndex"] !== undefined ? _data["orderIndex"] : <any>null;
            this.score = _data["score"] !== undefined ? _data["score"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
        }
    }

    static fromJS(data: any): ChoiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChoiceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["choiceId"] = this.choiceId !== undefined ? this.choiceId : <any>null;
        data["orderIndex"] = this.orderIndex !== undefined ? this.orderIndex : <any>null;
        data["score"] = this.score !== undefined ? this.score : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        return data; 
    }
}

export interface IChoiceRequest {
    choiceId: string;
    orderIndex: number;
    score: number;
    title: string;
}

export enum HttpStatusCode {
    Continue = "Continue",
    SwitchingProtocols = "SwitchingProtocols",
    Processing = "Processing",
    EarlyHints = "EarlyHints",
    OK = "OK",
    Created = "Created",
    Accepted = "Accepted",
    NonAuthoritativeInformation = "NonAuthoritativeInformation",
    NoContent = "NoContent",
    ResetContent = "ResetContent",
    PartialContent = "PartialContent",
    MultiStatus = "MultiStatus",
    AlreadyReported = "AlreadyReported",
    IMUsed = "IMUsed",
    MultipleChoices = "Ambiguous",
    Ambiguous = "Ambiguous",
    MovedPermanently = "Moved",
    Moved = "Moved",
    Found = "Redirect",
    Redirect = "Redirect",
    SeeOther = "RedirectMethod",
    RedirectMethod = "RedirectMethod",
    NotModified = "NotModified",
    UseProxy = "UseProxy",
    Unused = "Unused",
    TemporaryRedirect = "TemporaryRedirect",
    RedirectKeepVerb = "TemporaryRedirect",
    PermanentRedirect = "PermanentRedirect",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    PaymentRequired = "PaymentRequired",
    Forbidden = "Forbidden",
    NotFound = "NotFound",
    MethodNotAllowed = "MethodNotAllowed",
    NotAcceptable = "NotAcceptable",
    ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
    RequestTimeout = "RequestTimeout",
    Conflict = "Conflict",
    Gone = "Gone",
    LengthRequired = "LengthRequired",
    PreconditionFailed = "PreconditionFailed",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    RequestUriTooLong = "RequestUriTooLong",
    UnsupportedMediaType = "UnsupportedMediaType",
    RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
    ExpectationFailed = "ExpectationFailed",
    MisdirectedRequest = "MisdirectedRequest",
    UnprocessableEntity = "UnprocessableEntity",
    Locked = "Locked",
    FailedDependency = "FailedDependency",
    UpgradeRequired = "UpgradeRequired",
    PreconditionRequired = "PreconditionRequired",
    TooManyRequests = "TooManyRequests",
    RequestHeaderFieldsTooLarge = "RequestHeaderFieldsTooLarge",
    UnavailableForLegalReasons = "UnavailableForLegalReasons",
    InternalServerError = "InternalServerError",
    NotImplemented = "NotImplemented",
    BadGateway = "BadGateway",
    ServiceUnavailable = "ServiceUnavailable",
    GatewayTimeout = "GatewayTimeout",
    HttpVersionNotSupported = "HttpVersionNotSupported",
    VariantAlsoNegotiates = "VariantAlsoNegotiates",
    InsufficientStorage = "InsufficientStorage",
    LoopDetected = "LoopDetected",
    NotExtended = "NotExtended",
    NetworkAuthenticationRequired = "NetworkAuthenticationRequired",
}

export class DeleteAssignmentBulkRequest implements IDeleteAssignmentBulkRequest {
    residentIds!: string[];

    constructor(data?: IDeleteAssignmentBulkRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.residentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["residentIds"])) {
                this.residentIds = [] as any;
                for (let item of _data["residentIds"])
                    this.residentIds!.push(item);
            }
            else {
                this.residentIds = <any>null;
            }
        }
    }

    static fromJS(data: any): DeleteAssignmentBulkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteAssignmentBulkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.residentIds)) {
            data["residentIds"] = [];
            for (let item of this.residentIds)
                data["residentIds"].push(item);
        }
        return data; 
    }
}

export interface IDeleteAssignmentBulkRequest {
    residentIds: string[];
}

export class AssignmentResponse implements IAssignmentResponse {
    paused!: boolean;
    activeForResident!: boolean;
    draft!: boolean;
    residentId!: string;

    constructor(data?: IAssignmentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paused = _data["paused"] !== undefined ? _data["paused"] : <any>null;
            this.activeForResident = _data["activeForResident"] !== undefined ? _data["activeForResident"] : <any>null;
            this.draft = _data["draft"] !== undefined ? _data["draft"] : <any>null;
            this.residentId = _data["residentId"] !== undefined ? _data["residentId"] : <any>null;
        }
    }

    static fromJS(data: any): AssignmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paused"] = this.paused !== undefined ? this.paused : <any>null;
        data["activeForResident"] = this.activeForResident !== undefined ? this.activeForResident : <any>null;
        data["draft"] = this.draft !== undefined ? this.draft : <any>null;
        data["residentId"] = this.residentId !== undefined ? this.residentId : <any>null;
        return data; 
    }
}

export interface IAssignmentResponse {
    paused: boolean;
    activeForResident: boolean;
    draft: boolean;
    residentId: string;
}

export class GetResidentsIdsAssignedToFormIdsBulkRequest implements IGetResidentsIdsAssignedToFormIdsBulkRequest {
    formIds!: string[];

    constructor(data?: IGetResidentsIdsAssignedToFormIdsBulkRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.formIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["formIds"])) {
                this.formIds = [] as any;
                for (let item of _data["formIds"])
                    this.formIds!.push(item);
            }
            else {
                this.formIds = <any>null;
            }
        }
    }

    static fromJS(data: any): GetResidentsIdsAssignedToFormIdsBulkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetResidentsIdsAssignedToFormIdsBulkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.formIds)) {
            data["formIds"] = [];
            for (let item of this.formIds)
                data["formIds"].push(item);
        }
        return data; 
    }
}

export interface IGetResidentsIdsAssignedToFormIdsBulkRequest {
    formIds: string[];
}

export class AssignmentRequest implements IAssignmentRequest {
    paused?: boolean | null;
    activeForResident!: boolean;
    draft!: boolean;

    constructor(data?: IAssignmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paused = _data["paused"] !== undefined ? _data["paused"] : <any>null;
            this.activeForResident = _data["activeForResident"] !== undefined ? _data["activeForResident"] : <any>null;
            this.draft = _data["draft"] !== undefined ? _data["draft"] : <any>null;
        }
    }

    static fromJS(data: any): AssignmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssignmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paused"] = this.paused !== undefined ? this.paused : <any>null;
        data["activeForResident"] = this.activeForResident !== undefined ? this.activeForResident : <any>null;
        data["draft"] = this.draft !== undefined ? this.draft : <any>null;
        return data; 
    }
}

export interface IAssignmentRequest {
    paused?: boolean | null;
    activeForResident: boolean;
    draft: boolean;
}

export class AssignToResidentsRequest implements IAssignToResidentsRequest {
    residentIds!: string[];

    constructor(data?: IAssignToResidentsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.residentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["residentIds"])) {
                this.residentIds = [] as any;
                for (let item of _data["residentIds"])
                    this.residentIds!.push(item);
            }
            else {
                this.residentIds = <any>null;
            }
        }
    }

    static fromJS(data: any): AssignToResidentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssignToResidentsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.residentIds)) {
            data["residentIds"] = [];
            for (let item of this.residentIds)
                data["residentIds"].push(item);
        }
        return data; 
    }
}

export interface IAssignToResidentsRequest {
    residentIds: string[];
}

export class AnswerBatchRequestBody implements IAnswerBatchRequestBody {
    registrationIds!: string[];

    constructor(data?: IAnswerBatchRequestBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.registrationIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["registrationIds"])) {
                this.registrationIds = [] as any;
                for (let item of _data["registrationIds"])
                    this.registrationIds!.push(item);
            }
            else {
                this.registrationIds = <any>null;
            }
        }
    }

    static fromJS(data: any): AnswerBatchRequestBody {
        data = typeof data === 'object' ? data : {};
        let result = new AnswerBatchRequestBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.registrationIds)) {
            data["registrationIds"] = [];
            for (let item of this.registrationIds)
                data["registrationIds"].push(item);
        }
        return data; 
    }
}

export interface IAnswerBatchRequestBody {
    registrationIds: string[];
}

export class AnswersForRegistrationsRequestsBody implements IAnswersForRegistrationsRequestsBody {
    registrationRequests!: RegistrationRequest[];

    constructor(data?: IAnswersForRegistrationsRequestsBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.registrationRequests = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["registrationRequests"])) {
                this.registrationRequests = [] as any;
                for (let item of _data["registrationRequests"])
                    this.registrationRequests!.push(RegistrationRequest.fromJS(item));
            }
            else {
                this.registrationRequests = <any>null;
            }
        }
    }

    static fromJS(data: any): AnswersForRegistrationsRequestsBody {
        data = typeof data === 'object' ? data : {};
        let result = new AnswersForRegistrationsRequestsBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.registrationRequests)) {
            data["registrationRequests"] = [];
            for (let item of this.registrationRequests)
                data["registrationRequests"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAnswersForRegistrationsRequestsBody {
    registrationRequests: RegistrationRequest[];
}

export class RegistrationRequest implements IRegistrationRequest {
    residentId!: string;
    registrationId!: string;
    formId!: string;

    constructor(data?: IRegistrationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.residentId = _data["residentId"] !== undefined ? _data["residentId"] : <any>null;
            this.registrationId = _data["registrationId"] !== undefined ? _data["registrationId"] : <any>null;
            this.formId = _data["formId"] !== undefined ? _data["formId"] : <any>null;
        }
    }

    static fromJS(data: any): RegistrationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["residentId"] = this.residentId !== undefined ? this.residentId : <any>null;
        data["registrationId"] = this.registrationId !== undefined ? this.registrationId : <any>null;
        data["formId"] = this.formId !== undefined ? this.formId : <any>null;
        return data; 
    }
}

export interface IRegistrationRequest {
    residentId: string;
    registrationId: string;
    formId: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}